import React, { useEffect, useRef,useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from 'react-router-dom';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { loadModules } from 'esri-loader';
import { faRoad, faHome, faPlus, faMinus, faTimes, faSearch, faExclamationCircle, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@material-ui/core';
import Cookies, { set } from 'js-cookie';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import API_PATH from "../../constants/config.json";
import { Typography } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { clearCookie, setCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import LayersIcon from '@material-ui/icons/Layers';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { useTheme } from '@material-ui/core/styles';

import Container from '@material-ui/core/Container';
import PersonIcon from '@material-ui/icons/Person';
import RoomIcon from '@material-ui/icons/Room';
import CssBaseline from '@material-ui/core/CssBaseline';
import FilledInput from '@material-ui/core/FilledInput';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LaneGeometry from './LaneGeometry';
import Checkbox from '@material-ui/core/Checkbox';
import MapContext from '../../context/MapContext'

const axios = require('axios');

const API_URL = process.env.REACT_APP_BASE_URL;
let aproachDetailsError=[false,false,false,false];
let losDirectionsError=[true,true,true,true];

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography component="div">{children}</Typography>
          </Box>
        )}
      </div>
    );
}
  
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
  
function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
}
//Start Css Code ....
const useStyles = makeStyles((theme) => ({
    root: {
        '& .esri-ui-bottom-right' :{
            padding: "0px 10px 10px 10px",
            right: "30px !important",
              bottom: "14px !important",
          },
        '& .esri-ui-bottom-right' :{
            padding: "0px 10px 10px 10px",
            right: "30px !important",
              bottom: "14px !important",
          },
        flexGrow: 1,
        '& .MuiTextField-root': {
            width: '100%',
            '@media only screen and (min-width: 3501px)': {
                marginBottom: '20px',
            },
            '& input': {
                padding: '10px',
                color: '#333',
                '@media only screen and (max-width: 3500px)': {
                    fontSize: '13pt',
                },
                '@media only screen and (min-width: 3501px)': {
                    fontSize: '23pt',
                },
            },
        }
    },
    paper: {
        padding: '0px 0px',
        boxShadow: 'none',
    },
    fieldsetname: {
        width: 'auto',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px 10px 25px',
        marginTop: '15px',        
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    fieldsetnameInner: {
        width: '90%',
        border: '1px solid #ccc',
        padding: '10px 10px 25px',
        marginTop: '15px',       
        borderRadius: '5px',
        '& p': {
            margin: '0',
        },
        '& .MuiGrid-item': {
            paddingBottom: '0px',
        }
    },
    
    labelText: {
        width: '100%',
        float: 'left',
        color: '#333',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
        },
    },
    rootForm: {
        '@media only screen and (max-width: 3500px)': {
            '& h5': {                
                margin: '0',
            }
        },
        '@media only screen and (min-width: 3501px)': {
            '& h5': {
                fontSize: '28pt !important',
                margin: '0',
                marginTop: '10px',
            }
        },
    },
    locationMapView: {
        '& img': {
            width: '100%',
        },
        position:'relative', 
        '@media only screen and (max-width: 3500px)': {
            height: '278px',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '278px',
        },
    },
    btbBlock: {
        float: 'right',
    },
    btbBlock2: {
        width: '49%',
        textAlign: 'right',
        paddingBottom: '10px',
        '@media only screen and (max-width: 3500px)': {
            marginBottom: '10px',
        },
        '@media only screen and (min-width: 3501px)': {
            marginBottom: '25px',
        },
    },
    addStationBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '200px',
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    cancelBtn: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '14pt',
            width: '150px',
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt',
            width: '200px',
        },
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    importStationFile: {
        border: '1px solid #333',
        color: '#333',
        background: '#fff!important',
        fontSize: '12px',
        width: '200px',
        '&:hover': {
            boxShadow: '4px 3px 3px 0px #999',
        }
    },
    mapViewSection: {
        padding: '0 15px 0px 25px',
        marginTop: '64px',
        '& .hideInteraction': {
            display: 'none',
        },
        '& .hideMidBlock': {
            display: 'none',
        }
    },
    interApprochMainBlock: {
    
    },

    zoomIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #D4D4D8',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '6px',
        zIndex: '1',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    inIcon: {
        position: 'relative',
        color: '#24618E',
        border: '1px solid #D4D4D8',
        background: '#fff',
        textAlign: 'center',
        padding: '5px',
        marginBottom: '10px',
        cursor: 'pointer',
        borderRadius: '6px',
        zIndex: '1',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)',
        '@media only screen and (max-width: 3500px)': {
            width: '40px',
            fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '70px',
            height: '65px',
            '& svg': {
                fontSize: '35pt',
            }
        },
    },
    mapContainer: {
        width: '100% !important',
        display: 'block !important',
        '@media only screen and (max-width: 3500px)': {
            height: '278px !important'
        },
        '@media only screen and (min-width: 3501px)': {
            height: '278px !important',
        },
        '& .esri-view-root': {
            height: '100% !important',
            width: '100% !important'
        }
    },
    approachError: {
        marginBottom: '10px',
        '& span': {
            fontSize: '11pt !important'
        },
        '& .MuiPaper-elevation6': {
            flexGrow: 'unset',
            width: '100%'
        }
    },
    rightClickInfo: {
        position: 'absolute',       
        border: '1px solid #24618E',
        textAlign: 'center',
        padding: '5px',
        background: '#f2f2f2',
        borderTop: 'none',
        borderLeft: 'none',
        zIndex: 1,
        '@media only screen and (max-width: 3500px)': {
            width: '400px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '650px',
            fontSize:'24pt'
        },
    },
    iconBox: {
        position: 'absolute', 
        width: 'max-content',        
        width: 'max-content',        
        paddingLeft: '0px',        
        right: '8px',
        '@media only screen and (max-width: 3500px)': {            
            bottom: '8px'
        },
        '@media only screen and (min-width: 3501px)': {
            bottom: '8px'
        },
    },
    layerButton: {
        position: 'absolute',
        right: '5px',
        top: '5px',
        zIndex: 1
    },
    showBtn: {
        color: '#24618E',
        border: '1px solid #24618E',
        fontSize: '12px',
        background: '#fff !important',
        padding: '5px',
        '@media only screen and (max-width: 3500px)': {
          height: '38px',
          minWidth: '40px !important',
        },
        '@media only screen and (min-width: 3501px)': {
          height: '57px',
          minWidth: '60px !important',
        },
      },
    hideBtn: {
        // color: '#24618E',
        // border: '1px solid #24618E',
        fontSize: '12px',
        background: '#24618E !important',
        padding: '5px',
        '@media only screen and (max-width: 3500px)': {
          height: '38px',
          minWidth: '40px !important',
        },
        '@media only screen and (min-width: 3501px)': {
          height: '57px',
          minWidth: '60px !important',
        },
    },
    deleteStation: {
        width: '100%',
        float: 'left',
        textAlign: 'right',
        marginTop: '-50px',
        '& button': {
            border: "1px solid #24618E",
            borderRadius: '5px',
            marginBottom: "10px"
        }
    },
    deletePopup: {
        '& .MuiDialogContent-root': {
            padding: '10px 15px',
        },
        '& .MuiPaper-root': {
            border: '1px solid #24618d',
            width: '525px',
        },
        '& .MuiDialogActions-root': {
            justifyContent: 'center',
            paddingTop: '30px'
        }
    },
    crossIcon: {
        color: '#24618d',
        fontSize: '20pt',
        fontFamily: 'Avenir_Black',
        fontWeight: '800',
        position: 'absolute',
        width: '40px !important',
        right: '5px',
        "&:hover": {
            // color: "#CC0000",
            cursor: 'pointer',
        }
    },
    header: {
        fontWeight: '800',
        color: '#24618d',
        fontFamily: 'Avenir_Black',
        fontSize: '18pt',
    },
    errorMsg: {
        backgroundColor: "#F2DEDE",
        border: "1px solid #CC0000",
        fontFamily: 'Avenir_Black',
        fontSize: '14pt',
        padding: '5px',
        marginBottom: '15px'
        , borderRadius: '5px'
    },
    heading: {
        fontFamily: '"Avenir_light" !important',
        fontSize: '14pt',
        lineHeight: '23px',
    },
    infoErrorIcon: {
        color: '#CC0000',
        fontSize: '25px',
        position: 'relative',
        top: '4px',
        marginRight: '10px',
    },
    clearBtn: {
        border: '1px solid #333',
        color: '#333',
        // fontSize: '12px',
        width: '150px',
        marginRight: '10px',
        textTransform: 'capitalize',
        padding: '3px 5px',
        lineHeight: 'normal',
        letterSpacing: '0',
        '& .MuiButton-root': {
          letterSpacing: '0',
        }
      },
      delBtn: {
        border: '1px solid #24618E',
        color: '#fff',
        background: '#24618E!important',
        width: '150px',
        marginRight: '10px',
        textTransform: 'capitalize',
        padding: '3px 10px',
        lineHeight: 'normal',
        letterSpacing: '0',
        '& .MuiButton-root': {
          letterSpacing: '0',
        }
    },
    btnIcon: {
        '@media only screen and (max-width: 3500px)': {
          fontSize: '20px',
        },
        '@media only screen and (min-width: 3501px)': {
          fontSize: '40px',
        },
    },
    mainpopup: {
        background: '#fff',
        position: 'absolute',
        margin: '10px auto 0',
        border: '1px solid #24618E',
        borderRadius: '5px',
        left: '10px',
        top: '45px',
        padding: '10px',
        width: '90%'
    }
}));
//End Css Code ....

let speedLimitField = 'none';

//Start StationDetails component code ....
const StationDetails = props => {
    const { setNeedToReload, needToReload,updateList } = props;
    
    
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [usTab, setUsTab] = React.useState("fo");
    const [teTab, setTeTab] = React.useState("fo");


    let history = useHistory();
    const [interactionApproch, setInteractionApproch] = React.useState("hideInteraction");
    const [midBlockApproch, setMidBlockApproch] = React.useState({ label: "hideMidBlock" });
    const [home, setHome] = React.useState(null);
    const [zoom, setZoom] = React.useState(null);
    const [lat, setLat] = React.useState(38.815709858000616);
    const [long, setLong] = React.useState(-77.09734972101597);
    const [stationLocation, setStationLocation] = React.useState('');
    const [stationType, setStationType] = React.useState(0);
    const [stationTypeName, setStationTypeName] = React.useState('Select');
    const [stationPrivacy, setStationPrivacy] = React.useState(0);
    const [displayName, setDisplayName] = React.useState(0);
    const [stationId, setStationId] = React.useState(0);
    const [status, setStatus] = React.useState('');
    const [agencyState, setAgencyState] = React.useState('');
    const [jurisdiction, setJurisdiction] = React.useState('');
    const [county, setCounty] = React.useState('');
    const [community, setCommunity] = React.useState('');
    const [speedLimit, setSpeedLimit] = React.useState('');
    const [description, setDescription] = React.useState('');
    const [seasonalFG, setSeasonalFG] = React.useState('');
    const [annualFG, setAnnualFG] = React.useState('');
    const [growthFG, setGrowthFG] = React.useState('');
    const [year, setYear] = React.useState('');
    const [NHS, setNHS] = React.useState('');
    const [PRS, setPRS] = React.useState('');
    const [fccDropdownVal, setFccDropdownVal] = React.useState('');
    const [ppDropdownVal, setPpDropdownVal] = React.useState('');
    const [prsDropdownVal, setPrsDropdownVal] = React.useState('');
    const [postedSpeedLimit, setPostedSpeedLimit] = React.useState('');
    const [losNB, setLosNB] = React.useState('');
    const [losSB, setLosSB] = React.useState('');
    const [losEB, setLosEB] = React.useState('');
    const [losWB, setLosWB] = React.useState('');
    const [losNBTurn, setLosNBTurn] = React.useState('');
    const [losSBTurn, setLosSBTurn] = React.useState('');
    const [losEBTurn, setLosEBTurn] = React.useState('');
    const [losWBTurn, setLosWBTurn] = React.useState('');
    const [medianType, setMedianType] = React.useState(null);
    const [stateRoad, setStateRoad] = React.useState('');
    const [nbExclusiveLeft, setNBExclusiveLeft] = React.useState('');
    const [sbExclusiveLeft, setSBExclusiveLeft] = React.useState('');
    const [ebExclusiveLeft, setEBExclusiveLeft] = React.useState('');
    const [wbExclusiveLeft, setWBExclusiveLeft] = React.useState('');
    const [nbExclusiveRight, setNBExclusiveRight] = React.useState('');
    const [sbExclusiveRight, setSBExclusiveRight] = React.useState('');
    const [ebExclusiveRight, setEBExclusiveRight] = React.useState('');
    const [wbExclusiveRight, setWBExclusiveRight] = React.useState('');
    const [oneWayRoadway, setOneWayRoadway] = React.useState('');
    const [auxiliaryLanes, setAuxiliaryLanes] = React.useState('');

    const [initialLat, setInitialLat] = React.useState(38.815709858000616);
    const [initialLong, setInitialLong] = React.useState(-77.09734972101597);
    const [initialStationLocation, setInitialStationLocation] = React.useState('');
    const [initialStationType, setInitialStationType] = React.useState(0);
    const [initialStationPrivacy, setInitialStationPrivacy] = React.useState(0);
    const [initialDisplayName, setInitialDisplayName] = React.useState(0);
    const [initialStationId, setInitialStationId] = React.useState(0);
    const [initialStatus, setInitialStatus] = React.useState('');
    const [initialAgencyState, setInitialAgencyState] = React.useState('');
    const [initialJurisdiction, setInitialJurisdiction] = React.useState('');
    const [initialCounty, setInitialCounty] = React.useState('');
    const [initialCommunity, setInitialCommunity] = React.useState('');
    const [initialSpeedLimit, setInitialSpeedLimit] = React.useState('');
    const [initialDescription, setInitialDescription] = React.useState('');
    const [initialSeasonalFG, setInitialSeasonalFG] = React.useState('');
    const [initialAnnualFG, setInitialAnnualFG] = React.useState('');
    const [initialGrowthFG, setInitialGrowthFG] = React.useState('');
    const [initialYear, setInitialYear] = React.useState('');
    const [initialNHS, setInitialNHS] = React.useState('');
    const [initialPRS, setInitialPRS] = React.useState('');
    const [initialFccDropdownVal, setInitialFccDropdownVal] = React.useState('');
    const [initialPpDropdownVal, setInitialPpDropdownVal] = React.useState('');
    const [initialPrsDropdownVal, setInitialPrsDropdownVal] = React.useState('');
    const [initialPostedSpeedLimit, setInitialPostedSpeedLimit] = React.useState('');
    const [initialLosNB, setInitialLosNB] = React.useState('');
    const [initialLosSB, setInitialLosSB] = React.useState('');
    const [initialLosEB, setInitialLosEB] = React.useState('');
    const [initialLosWB, setInitialLosWB] = React.useState('');
    const [initialLosNBTurn, setInitialLosNBTurn] = React.useState('');
    const [initialLosSBTurn, setInitialLosSBTurn] = React.useState('');
    const [initialLosEBTurn, setInitialLosEBTurn] = React.useState('');
    const [initialLosWBTurn, setInitialLosWBTurn] = React.useState('');
    const [initialMedianType, setInitialMedianType] = React.useState('');
    const [initialStateRoad, setInitialStateRoad] = React.useState('');
    const [initialNBExclusiveLeft, setInitialNBExclusiveLeft] = React.useState('');
    const [initialSBExclusiveLeft, setInitialSBExclusiveLeft] = React.useState('');
    const [initialEBExclusiveLeft, setInitialEBExclusiveLeft] = React.useState('');
    const [initialWBExclusiveLeft, setInitialWBExclusiveLeft] = React.useState('');
    const [initialNBExclusiveRight, setInitialNBExclusiveRight] = React.useState('');
    const [initialSBExclusiveRight, setInitialSBExclusiveRight] = React.useState('');
    const [initialEBExclusiveRight, setInitialEBExclusiveRight] = React.useState('');
    const [initialWBExclusiveRight, setInitialWBExclusiveRight] = React.useState('');
    const [initialOneWayRoadway, setInitialOneWayRoadway] = React.useState('');
    const [initialAuxiliaryLanes, setInitialAuxiliaryLanes] = React.useState('');

    const [fccDropdown, setFccDropdown] = React.useState([]);
    const [primaryPurposeDropdown, setPrimaryPurposeDropdown] = React.useState([]);
    const [prsDropdown, setPrsDropdown] = React.useState([]);

    const [approaches, setApproaches] = React.useState([]);
    const [initialApproaches, setInitialApproaches] = React.useState([]);
    const [getErr, setErr] = React.useState({});

    const [resetForm, setResetForm] = React.useState(false);
    const [midApproachSelectOneErr, setMidApproachSelectOneErr] = React.useState(false);

    const [areaClassifications, setAreaClassifications] = useState([]);
    const [medianTypes, setMedianTypes] = useState([]);

    const [areaClassError, setAreaClassError] = useState(false);
    const [medianTypeError, setMedianTypeError] = useState(false);
    const {updateStationDetails}=useContext(MapContext)


    const [values, setValues] = React.useState({
        station_type: 0,
        station_type_name: '',
        station_privacy: 1,
        station_location: '',
        display_name: '',
        client_station_id: '',
        status: 'active',
        latitude: 0,
        longitude: 0,
        state_code: '',
        fips_county_code: '',
        jurisdiction: '',
        community: '',
        speed_limit: null,
        FK_functional_classification_code: null,
        FK_primary_purpose: null,
        description: '',
        seasonal_factor_group: '',
        annual_factor_group: '',
        growth_factor_group: '',
        year_station_established: null,
        national_highway_system: null,
        FK_posted_route_signing: null,
        posted_signed_route_number: '',
        nb_approach: '',
        sb_approach: '',
        swb_approach: '',
        seb_approach: '',
        neb_approach: '',
        nwb_approach: '',
        eb_approach: '',
        wb_approach: ''
    });

    const [midAllApproaches, setMidAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {}
    });

    const [intAllApproaches, setIntAllApproaches] = React.useState({
        approachOne: {},
        approachTwo: {},
        approachThree: {},
        approachFour: {},
        approachFive: {},
        approachSix: {},
        approachSeven: {},
        approachEight: {},
    });

    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [loader, setLoader] = React.useState(false);

    const [approachError, setApproachError] = React.useState(false);
    const [approachErrorBlank, setApproachErrorBlank] = React.useState(false);

    const mapRef = useRef();
    const classes = useStyles();
    let view = null;
    let acccessToken = null;

    const [tempMapView, setTempMapView] = React.useState(null);
    const [geocodeAcccessToken, setGeocodeAcccessToken] = React.useState(null);
    const [getEnableFlag, setEnableFlag] = React.useState();
    const [stationTypeValue, setStationTypeValue] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [getFileName, setFileName] = React.useState();
    const [myFileID, setMyFileId] = React.useState();
    const [successMsg, setSuccessMsg] = React.useState(false);
    const [stationList, setStationList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [getLoader, setLoaderDisable] = React.useState(false);
    const [userAccess, setUserAccess] = React.useState(true);
    // const [midApproachSelectOneErr, setMidApproachSelectOneErr] = React.useState(false);
    const [midApproachSelectTwoErr, setMidApproachSelectTwoErr] = React.useState(false);

    const [intApproachSelectOneErr, setIntApproachSelectOneErr] = React.useState(false);
    const [intApproachSelectTwoErr, setIntApproachSelectTwoErr] = React.useState(false);
    const [intApproachSelectThreeErr, setIntApproachSelectThreeErr] = React.useState(false);
    const [intApproachSelectFourErr, setIntApproachSelectFourErr] = React.useState(false);
    const [getApprochReset, setApprochReset] = React.useState([]);
    const [getFlag,setFlag]= React.useState(sessionStorage.getItem("deleteFlag"));

    const [displayNameError,setDisplayNameError]= React.useState(false);
    const [stationLocationError,setStationLocationError]= React.useState(false);
    const [stationIdError,setStationIdError]= React.useState(false);
    const [stationLatitudeError,setStationLatitudeError]= React.useState(false);
    const [stationLongitudeError,setStationLongitudeError]= React.useState(false);
    const [stationDetailsError,setStationDetailsError]= React.useState(false);
    const [formErrorMessage,setFormErrorMessage]= React.useState('');
    

    
    //
    const [stationHasData, setStationHasData] = React.useState(false);
    let enteriesPerPage = 25;

    // basemap selection
    const [getMapLayer, setMapLayer] = React.useState(false);

    const [scrolled, setScrolled] = useState(false);
    const mainBgRef = useRef();

    const [miscellaneous, setMiscellaneous] = React.useState('');

    const [showLaneConfig, setShowLaneConfig] = React.useState(false);
    const [losEnabled, setLosEnabled] = React.useState(false);
    const [showLOS, setShowLOS] = React.useState(false);
    const [selectedAreaClassification, setSelectedAreaClassification] = React.useState([]);
    const [laneConfigId, setLaneConfigId] = useState(null);

    const [approachesForLane, setApproachesForLane] = useState([]);
    const [losDisabledApproaches, setLosDisabledApproaches] = useState([]);

    useEffect(
        () => {
            // getFFCdropdown();
            // getPrimPPdropdown();
            // getPRSdropdown();
            aproachDetailsError=[false,false,false,false]
            losDirectionsError=[];
            getStationTypeData();
            checkHasStationData();
            getStationDetails();
            getMedianType();
            getAreaClassifications();
            getMapAccessToken();
          setLosDisabledApproaches([]);
        }, []
    );

    const getAreaClassifications = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getAreaClassifications,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setAreaClassifications(response.data.result);
                    }
                    else {
                        setAreaClassifications([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getMedianType = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getMedianType,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setMedianTypes(response.data.result);
                    }
                    else {
                        setMedianTypes([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }
    

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const checkHasStationData = () => {
        try {
            axios({
                method: 'post',
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.stationHasData + `${sessionStorage.getItem('viewStationId')}`,
            })
                .then(async function (response) {
                    if(response.status == 200){
                        let checkStationHasData = response.data.data; 
                        setStationHasData(checkStationHasData);               
                    }else{
                        console.error(response)
                    }                   
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const getMapAccessToken = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getArcGISToken,
                headers: {
                    'payload': Cookies.get('payload'),
                },
            })
                .then(async function (response) {
                    acccessToken = response.data.access_token;
                    setGeocodeAcccessToken(response.data.access_token);
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    const homeEvent = () => { // event to go at initial view
        home.go();
      
        home.on("go", function (event) {

        })
    }
    const ZoomInEvent = () => { // event to zoom in map
        zoom.zoomIn();

    }
    const zoomOutEvent = () => { // event to zoom out map
        zoom.zoomOut();

    }

    // This funtion is for get all station data
    const getStationTypeData = () => {
        try {
            axios({
                method: 'GET',
                url: API_URL + API_PATH.getStationType,
            })
                .then(async function (response) {
                    if (response && response.status == 200) {
                        setStationTypeValue(response.data.data);
                    }
                    else {
                        setStationTypeValue([]);
                    }
                })
                .catch(function (error) {
                    console.error(error);
                })
        } catch (error) {

            console.error(error);
        }
    }

    // This function is for Interaction Approches start
    const showInterractionApproches = (e) => {
        setApproachError(false);
        setApproachErrorBlank(false);
        // values.station_type_name = (e.target.value == 1 ? "midblock" : "intersection") ;
        // setValues(values);
        // let filterSpace = approaches.filter(function (el,index) { return Object.values(el)[index] != ""; });
        let stationType = document.getElementById('station_Type');
        setStationType(stationType.value);
        setValues({ ...values, "station_type_name": e.target.value == 1 ? "midblock" : "intersection", 'station_type': stationType.value });
        if (stationType.value == 2) {
            setInteractionApproch('displayInteraction');
            setMidBlockApproch('hideMidBlock');
            speedLimitField = 'none';
            // document.getElementById('intersection_Approaches_text_').value = '';
            document.getElementById('intersection_Approaches_text_1').value = '';
            document.getElementById('intersection_Approaches_text_2').value = '';
            document.getElementById('intersection_Approaches_text_3').value = '';
            document.getElementById('intersection_Approaches_text_4').value = '';
            document.getElementById('intersection_Approaches_select_1').value = '';
            document.getElementById('intersection_Approaches_select_2').value = '';
            document.getElementById('intersection_Approaches_select_3').value = '';
            document.getElementById('intersection_Approaches_select_4').value = '';
            setApproaches([
                { eb_approach: "" },
                { nb_approach: "" },
                { sb_approach: "" },
                { wb_approach: "" }
            ]);

        }
        else {
            setInteractionApproch('hideInteraction');
            setMidBlockApproch('displayMidBlock')
            document.getElementById('mid_Approaches_text_1').value = '';
            document.getElementById('mid_Approaches_text_2').value = '';
            document.getElementById('mid_Approaches_select_1').value = "null";
            document.getElementById('mid_Approaches_select_2').value = "null";
            setApproaches([
                { eb_approach: "" },
                { nb_approach: "" },
                { sb_approach: "" },
                { wb_approach: "" }]);


            setMidAllApproaches({ approachOne: {}, approachTwo: {} });


            speedLimitField = 'none';
        }
    }

    // This function is for Interaction Approches End
    const getStationDetails = () => { // API call to get team details
        try {
            axios({
                method: 'get',
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getStationInfoAPI + `${sessionStorage.getItem('viewStationId')}`,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let data = response.data.data;
                        let details = {
                            station_type: data.station_type,
                            update_flag: data.update_flag,
                            station_type_name: data.station_type_name,
                            station_privacy: data.station_privacy,
                            station_location: data.station_location,
                            display_name: data.display_name,
                            client_station_id: data.client_station_id,
                            status: data.status,
                            latitude: data.latitude,
                            longitude: data.longitude,
                            state_code: data.state_code,
                            fips_county_code: data.fips_county_code,
                            jurisdiction: data.jurisdiction,
                            community: data.community,
                            speed_limit: data.speed_limit,
                            FK_functional_classification_code: data.FK_functional_classification_code,
                            FK_primary_purpose: data.FK_primary_purpose,
                            description: data.description,
                            seasonal_factor_group: data.seasonal_factor_group,
                            annual_factor_group: data.annual_factor_group,
                            growth_factor_group: data.growth_factor_group,
                            year_station_established: data.year_station_established,
                            national_highway_system: data.national_highway_system,
                            FK_posted_route_signing: data.FK_posted_route_signing,
                            posted_signed_route_number: data.posted_signed_route_number,

                            nb_approach: data.nb_approach,
                            sb_approach: data.sb_approach,
                            swb_approach: data.swb_approach,
                            seb_approach: data.seb_approach,
                            neb_approach: data.neb_approach,
                            nwb_approach: data.nwb_approach,
                            eb_approach: data.eb_approach,
                            wb_approach: data.wb_approach,
                        };
                        if(data.station_type === 1 && data.enable_los_calculation === true) {
                            details['posted_speed_limit'] = data.posted_speed_limit;
                            details['nb_num_lanes'] = data.nb_num_lanes;
                            details['sb_num_lanes'] = data.sb_num_lanes;
                            details['eb_num_lanes'] = data.eb_num_lanes;
                            details['wb_num_lanes'] = data.wb_num_lanes;
                            details['nb_left_turn_within_100_yards'] = data.nb_left_turn_within_100_yards ? "Yes" : "No";
                            details['sb_left_turn_within_100_yards'] = data.sb_left_turn_within_100_yards ? "Yes" : "No";
                            details['eb_left_turn_within_100_yards'] = data.eb_left_turn_within_100_yards ? "Yes" : "No";
                            details['wb_left_turn_within_100_yards'] = data.wb_left_turn_within_100_yards ? "Yes" : "No";
                            details['FK_median_type_id'] = data.FK_median_type_id;
                            details['FK_area_classification_id'] = data.FK_area_classification_id;
                            details['state_roadway'] = data.state_roadway ? "Yes" : "No";
                            details['nb_exclusive_left_turn_lane'] = data.nb_exclusive_left_turn_lane ? "Yes" : "No";
                            details['sb_exclusive_left_turn_lane'] = data.sb_exclusive_left_turn_lane ? "Yes" : "No";
                            details['eb_exclusive_left_turn_lane'] = data.eb_exclusive_left_turn_lane ? "Yes" : "No";
                            details['wb_exclusive_left_turn_lane'] = data.wb_exclusive_left_turn_lane ? "Yes" : "No";
                            details['nb_exclusive_right_turn_lane'] = data.nb_exclusive_right_turn_lane ? "Yes" : "No";
                            details['sb_exclusive_right_turn_lane'] = data.sb_exclusive_right_turn_lane ? "Yes" : "No";
                            details['eb_exclusive_right_turn_lane'] = data.eb_exclusive_right_turn_lane ? "Yes" : "No";
                            details['wb_exclusive_right_turn_lane'] = data.wb_exclusive_right_turn_lane ? "Yes" : "No";
                            details['one_way_roadway'] = data.one_way_roadway ? "Yes" : "No";
                            details['auxiliary_lanes'] = data.auxiliary_lanes ? "Yes" : "No";
                            details['enable_los_calculation'] = data.enable_los_calculation;
                        }
                        setValues(details);

                        setStationType(data.station_type);
                        setEnableFlag(data.update_flag);
                        setStationTypeName(data.station_type_name);
                        setStationPrivacy(data.station_privacy);
                        setStationLocation(data.station_location);
                        setDisplayName(data.display_name);
                        setStationId(data.client_station_id);
                        setStatus(data.status);
                        setLat(data.latitude);
                        setLong(data.longitude);
                        setAgencyState(data.state_code);
                        setJurisdiction(data.jurisdiction);
                        setCounty(data.fips_county_code);
                        setCommunity(data.community);
                        setSpeedLimit(data.speed_limit);
                        setDescription(data.description);
                        setSeasonalFG(data.seasonal_factor_group);
                        setAnnualFG(data.growth_factor_group);
                        setGrowthFG(data.annual_factor_group);
                        setYear(data.year_station_established)
                        setNHS(data.national_highway_system);
                        setPRS(data.posted_signed_route_number);
                        setFccDropdownVal(data.FK_functional_classification_code);
                        setPpDropdownVal(data.FK_primary_purpose);
                        setPrsDropdownVal(data.FK_posted_route_signing);
                        setInitialLat(data.latitude);
                        setInitialLong(data.longitude);
                        setMiscellaneous((data.miscellaneous)?data.miscellaneous:'')
                        setPostedSpeedLimit(data.posted_speed_limit)
                        setLosNB(data.nb_num_lanes)
                        setLosSB(data.sb_num_lanes)
                        setLosEB(data.eb_num_lanes)
                        setLosWB(data.wb_num_lanes)
                        setLosNBTurn(data.nb_left_turn_within_100_yards ? "Yes" : "No")
                        setLosSBTurn(data.sb_left_turn_within_100_yards ? "Yes" : "No")
                        setLosEBTurn(data.eb_left_turn_within_100_yards ? "Yes" : "No")
                        setLosWBTurn(data.wb_left_turn_within_100_yards ? "Yes" : "No")
                        setMedianType(data.FK_median_type_id)
                        setStateRoad(data.state_roadway ? "Yes" : "No")
                        setNBExclusiveLeft(data.nb_exclusive_left_turn_lane ? "Yes" : "No")
                        setSBExclusiveLeft(data.sb_exclusive_left_turn_lane ? "Yes" : "No")
                        setEBExclusiveLeft(data.eb_exclusive_left_turn_lane ? "Yes" : "No")
                        setWBExclusiveLeft(data.wb_exclusive_left_turn_lane ? "Yes" : "No")
                        setNBExclusiveRight(data.nb_exclusive_right_turn_lane ? "Yes" : "No")
                        setSBExclusiveRight(data.sb_exclusive_right_turn_lane ? "Yes" : "No")
                        setEBExclusiveRight(data.eb_exclusive_right_turn_lane ? "Yes" : "No")
                        setWBExclusiveRight(data.wb_exclusive_right_turn_lane ? "Yes" : "No")
                        setOneWayRoadway(data.one_way_roadway ? "Yes" : "No")
                        setAuxiliaryLanes(data.auxiliary_lanes ? "Yes" : "No")
                        setSelectedAreaClassification(data.FK_area_classification_id)
                        setLosEnabled(data.enable_los_calculation)
                        setApproaches(
                            [
                            { eb_approach: data.eb_approach },
                            { nb_approach: data.nb_approach },
                            { sb_approach: data.sb_approach },
                            { wb_approach: data.wb_approach }
                            ].sort(function(a,b){return (Object.values(a)[0] == '')?1 : -1}));
                        setInitialLat(data.latitude);
                        setInitialLong(data.longitude);
                        setInitialStationLocation(data.station_location);
                        setInitialStationType(data.station_type);
                        setInitialStationPrivacy(data.station_privacy);
                        setInitialDisplayName(data.display_name);
                        setInitialStationId(data.client_station_id);
                        setInitialStatus(data.status);
                        setInitialAgencyState(data.state_code);
                        setInitialJurisdiction(data.jurisdiction);
                        setInitialCounty(data.fips_county_code);
                        setInitialCommunity(data.community);
                        setInitialSpeedLimit(data.speed_limit);
                        setInitialDescription(data.description);
                        setInitialSeasonalFG(data.seasonal_factor_group);
                        setInitialAnnualFG(data.growth_factor_group);
                        setInitialGrowthFG(data.annual_factor_group);
                        setInitialYear(data.year_station_established);
                        setInitialNHS(data.national_highway_system);
                        setInitialPRS(data.posted_signed_route_number);
                        setInitialFccDropdownVal(data.FK_functional_classification_code);
                        setInitialPpDropdownVal(data.FK_primary_purpose);
                        setInitialPrsDropdownVal(data.FK_posted_route_signing);
                        setInitialApproaches(
                            [
                                ...initialApproaches,
                                { eb_approach: data.eb_approach },
                                { nb_approach: data.nb_approach },
                                { sb_approach: data.sb_approach },
                                { swb_approach: data.swb_approach },
                                { seb_approach: data.seb_approach },
                                { neb_approach: data.neb_approach },
                                { nwb_approach: data.nwb_approach },
                                { wb_approach: data.wb_approach }
                            ]
                        )
                        setInitialPostedSpeedLimit(data.posted_speed_limit)
                        setInitialLosNB(data.nb_num_lanes)
                        setInitialLosSB(data.sb_num_lanes)
                        setInitialLosEB(data.eb_num_lanes)
                        setInitialLosWB(data.wb_num_lanes)
                        setInitialLosNBTurn(data.nb_left_turn_within_100_yards ? "Yes" : "No")
                        setInitialLosSBTurn(data.sb_left_turn_within_100_yards ? "Yes" : "No")
                        setInitialLosEBTurn(data.eb_left_turn_within_100_yards ? "Yes" : "No")
                        setInitialLosWBTurn(data.wb_left_turn_within_100_yards ? "Yes" : "No")
                        setInitialMedianType(data.FK_median_type_id)
                        setSelectedAreaClassification(data.FK_area_classification_id);
                        setInitialStateRoad(data.state_roadway ? "Yes" : "No")
                        setInitialNBExclusiveLeft(data.nb_exclusive_left_turn_lane ? "Yes" : "No")
                        setInitialSBExclusiveLeft(data.sb_exclusive_left_turn_lane ? "Yes" : "No")
                        setInitialEBExclusiveLeft(data.eb_exclusive_left_turn_lane ? "Yes" : "No")
                        setInitialWBExclusiveLeft(data.wb_exclusive_left_turn_lane ? "Yes" : "No")
                        setInitialNBExclusiveRight(data.nb_exclusive_right_turn_lane ? "Yes" : "No")
                        setInitialSBExclusiveRight(data.sb_exclusive_right_turn_lane ? "Yes" : "No")
                        setInitialEBExclusiveRight(data.eb_exclusive_right_turn_lane ? "Yes" : "No")
                        setInitialWBExclusiveRight(data.wb_exclusive_right_turn_lane ? "Yes" : "No")
                        setInitialOneWayRoadway(data.one_way_roadway ? "Yes" : "No")
                        setInitialAuxiliaryLanes(data.auxiliary_lanes ? "Yes" : "No")
                        let mapType = Cookies.get('stationDetailsMap') ? Cookies.get('stationDetailsMap') : 'streets-navigation-vector';
                       
                        loadMap(mapType, data.latitude, data.longitude,data.station_type);
                        if (data.station_type === 2) {
                            setIntAllApproaches([
                                { eb_approach: data.eb_approach },
                                { nb_approach: data.nb_approach },
                                { sb_approach: data.sb_approach },
                                { swb_approach: data.swb_approach },
                                { seb_approach: data.seb_approach },
                                { neb_approach: data.neb_approach },
                                { nwb_approach: data.nwb_approach },
                                { wb_approach: data.wb_approach }
                            ]);
                            setInteractionApproch('displayInteraction');
                            setMidBlockApproch('hideMidBlock');
                            speedLimitField = 'none';
                        }
                        else {
                            setMidAllApproaches([
                                { eb_approach: data.eb_approach },
                                { nb_approach: data.nb_approach },
                                { sb_approach: data.sb_approach },
                                { swb_approach: data.swb_approach },
                                { seb_approach: data.seb_approach },
                                { neb_approach: data.neb_approach },
                                { nwb_approach: data.nwb_approach },
                                { wb_approach: data.wb_approach }
                            ]);

                            setMidBlockApproch('displayMidBlock')
                            setInteractionApproch('hideInteraction');
                            speedLimitField = 'none';
                            // if (data.station_type === 1) {
                            //     speedLimitField = 'none';
                            //     setInteractionApproch('hideInteraction');
                            //     setMidBlockApproch('hideMidBlock');
                            // }
                        }

                        if(data && data.nb_approach || data.sb_approach){
                            document.getElementById('mid_Approaches_select_1').value = "NB";
                            document.getElementById('mid_Approaches_text_1').value = data.nb_approach;

                            document.getElementById('mid_Approaches_select_2').value = "SB";
                            document.getElementById('mid_Approaches_text_2').value = data.sb_approach;  
                            setLosDisabledApproaches(["nb","sb"]);
                        }

                        if(data && data.eb_approach || data.wb_approach){
                            document.getElementById('mid_Approaches_select_1').value = "EB";
                            document.getElementById('mid_Approaches_text_1').value = data.eb_approach;

                            document.getElementById('mid_Approaches_select_2').value = "WB";
                            document.getElementById('mid_Approaches_text_2').value = data.wb_approach;
                            setLosDisabledApproaches(["eb","wb"]);
                        }

                        // approaches used in lane geometry
                        setApproachesForLane(
                            [
                            { eb_approach: data.eb_approach },
                            { nb_approach: data.nb_approach },
                            { sb_approach: data.sb_approach },
                            { wb_approach: data.wb_approach }
                            ]
                        );

                        if(data && data.FK_lane_config_id) {
                            setLaneConfigId(data.FK_lane_config_id);
                        } else {
                            setLaneConfigId(null);
                        }
                    } else {

                    };
                })
                .catch(async function (error) {
                    if (error.response) {
                        if (error.response.status && error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }

    const clearStationForm = () => {
        document.getElementById('station_Type').value = initialStationType;
        setStationType(initialStationType);
        setStationPrivacy(initialStationPrivacy);
        setStationLocation(initialStationLocation);
        setDisplayName(initialDisplayName);
        setStationId(initialStationId);
        setStatus(initialStatus);
        setLat(initialLat);
        setLong(initialLong);
        setAgencyState(initialAgencyState);
        // setJurisdiction(initialJurisdiction);
        setCounty(initialCounty);
        // setCommunity(initialCommunity);
        // setSpeedLimit(initialSpeedLimit);
        // setDescription(initialDescription);
        // setSeasonalFG(initialSeasonalFG);
        // setAnnualFG(initialAnnualFG);
        // setGrowthFG(initialGrowthFG);
        // setYear(initialYear)
        // setNHS(initialNHS);
        // setPRS(initialPRS);
        // setFccDropdownVal(initialFccDropdownVal);
        // setPpDropdownVal(initialPpDropdownVal);
        // setPrsDropdownVal(initialPrsDropdownVal);
        if (initialStationType === 2) {

            setIntAllApproaches(initialApproaches);
            setInteractionApproch('displayInteraction');
            setMidBlockApproch('hideMidBlock');
            speedLimitField = 'none';
        }
        else {

            setMidAllApproaches(initialApproaches);
            setMidBlockApproch('displayMidBlock')
            setInteractionApproch('hideInteraction');
            speedLimitField = 'none';
        }
        let initialData = {
            ...values,
            station_type: initialStationType,
            station_privacy: initialStationPrivacy,
            station_location: initialStationLocation,
            display_name: initialDisplayName,
            client_station_id: initialStationId,
            status: initialStatus,
            latitude: initialLat,
            longitude: initialLong,
            state_code: initialAgencyState,
            fips_county_code: initialCounty,
            jurisdiction: initialJurisdiction,
            community: initialCommunity,
            speed_limit: initialSpeedLimit,
            FK_functional_classification_code: initialFccDropdownVal,
            FK_primary_purpose: initialPpDropdownVal,
            description: initialDescription,
            seasonal_factor_group: initialSeasonalFG,
            annual_factor_group: initialAnnualFG,
            growth_factor_group: initialGrowthFG,
            year_station_established: initialYear,
            national_highway_system: initialNHS,
            FK_posted_route_signing: initialPrsDropdownVal,
            posted_signed_route_number: initialPRS,
            station_type_name: initialStationType == 1 ? "midblock" : "intersection",
            initialApproaches,
            // getApprochReset
        }
        setValues({ ...values, ...initialData });
        // setMidAllApproaches();
        setResetForm(true);
        setPointer(initialLong, initialLat)
        props.setShowStationDetails(false)
    }

    const loadMap = (basemap = 'streets-navigation-vector', lat, lng,station_type) => {
        // lazy load the required ArcGIS API for JavaScript modules and CSS
        loadModules(['esri/Map', 'esri/views/MapView', "esri/widgets/Home", "esri/widgets/Zoom", "esri/layers/FeatureLayer", "esri/Viewpoint", "esri/geometry/Point", "esri/Graphic", "esri/layers/GraphicsLayer", "esri/symbols/PictureMarkerSymbol", "esri/widgets/Search",
        "esri/widgets/BasemapToggle",
        "esri/widgets/BasemapGallery"], { css: true })
            .then(([ArcGISMap, MapView, Home, Zoom, FeatureLayer, Viewpoint, Point, Graphic, GraphicsLayer, PictureMarkerSymbol, Search,
                BasemapToggle, BasemapGallery]) => {
                const map = new ArcGISMap({
                    basemap,
                    slider: false
                });

                view = new MapView({
                    container: mapRef.current,
                    map: map,
                    isPan: true,
                    // center: [-106.61, 35.1107],
                    zoom: 20,
                    ui: {
                        components: ['home', 'locate'] // specify only the components you want
                    },
                });
                let mapTypePrev = Cookies.get('stationDetailsMap') && Cookies.get('stationDetailsMap') === 'hybrid' ? 'streets-navigation-vector' : 'hybrid';
                var basemapToggle = new BasemapToggle({
                    view: view,  // The view that provides access to the map's "streets-vector" basemap
                    nextBasemap: mapTypePrev  // Allows for toggling to the "hybrid" basemap
                  });
            
                  //view.ui.add(basemapToggle,"bottom-right");
                 
                setTempMapView(view)
                let featureLayer = new FeatureLayer({
                    url: sessionStorage.getItem('mapURL')
                });
                map.add(featureLayer);
                featureLayer.when(function () { // adds feature layer to map view
                    let vp = new Viewpoint({
                        targetGeometry: featureLayer.fullExtent
                    });
                    homeButton.viewpoint = vp;
                    view.extent = featureLayer.fullExtent;
                    let point = new Point(lng, lat);
                    let pointSymbol = {
                        type: "simple-marker",
                        style: "circle",
                        color: "#00b15e",
                        size: 20,
                        outline: {
                            color: "#3676bc",
                            width: 0.5
                        }
                    }
                    let symbolInt = {
                        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                        url: require("../../assets/icons/marker_Intersection.png"),
                        width: "42px",
                        height: "42px",
                        yoffset: "20px"
                      };
                      let symbolMid = {
                        type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                        url: require("../../assets/icons/marker_Midblock.png"),
                        width: "42px",
                        height: "42px",
                        yoffset: "20px"
                      };
                      if (station_type==1){
                        pointSymbol=symbolMid;
                      }else{
                        pointSymbol=symbolInt;
                      }
                    let pointGraphic = new Graphic(point, pointSymbol);
                    view.graphics.add(pointGraphic);
                    view.goTo(pointGraphic).then(function () {
                        view.zoom = view.zoom + 5;
                    });
                });
                var search = new Search({
                    view: view
                });

                let homeButton = new Home({
                    view: view,
                });
                let zoom = new Zoom({
                    view: view,
                });
                setHome(homeButton)
                setZoom(zoom)

                let path = require('../../assets/images/mapPoint.svg')

                let draggingGraphic;
                let tempGraphic;
                let points;

                view.on("drag", function (evt) {
                    if (evt.action === 'start') {
                        view.hitTest(evt).then(resp => {
                           
                            if (resp.results[0].graphic && resp.results[0].graphic.geometry.type === 'point') {                                
                                evt.stopPropagation();
                                // if the hitTest returns a point graphic, set dragginGraphic
                                draggingGraphic = resp.results[0].graphic;
                            }
                        });
                    } else if (evt.action === 'update') {
                        // on drag update events, only continue if a draggingGraphic is set
                        if (draggingGraphic) {
                            evt.stopPropagation();
                            // if there is a tempGraphic, remove it
                            if (tempGraphic) {
                                view.graphics.remove(tempGraphic);
                            } else {
                                // if there is no tempGraphic, this is the first update event, so remove original graphic
                                view.graphics.remove(draggingGraphic);
                            }
                            // create new temp graphic and add it
                            tempGraphic = draggingGraphic.clone();
                            tempGraphic.geometry = view.toMap(evt);
                            view.graphics.add(tempGraphic);
                        }

                    } else if (evt.action === 'end') {
                        view.hitTest(evt).then(resp => {
                            if (resp.results[0].graphic && resp.results[0].graphic.geometry.type === 'point') {
                                points = resp.results[0].mapPoint;

                                if (draggingGraphic) {
                                    let instance = axios.create();
                                    delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                                    try {
                                        instance({
                                            method: 'GET',
                                            url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName &location=' + `${resp.results[0].mapPoint.longitude}` + ',' + `${resp.results[0].mapPoint.latitude}` + '&token=' + acccessToken

                                        })
                                            .then(async function (response) {
                                               
                                                if(response.data.error){
                                                
                                                    setLat("");
                                                    setLong("");
                                                    setStationLocation("");
                                                    
                                                    setAgencyState("");
                                                   // setAgencyState(stateCode[2]);
                                                    setCounty("");

                                                }else{
                                                    var address = response.data.address;
                                                    setLat(points.latitude);
                                                    setLong(points.longitude);

                                                    
                                                    setStationLocation(address.Match_addr);
                                                    if(address.Match_addr==''){
                                                        setStationLocationError(true)
                                                    }else{
                                                        setStationLocationError(false)
                                                    }
                                                    let stateCode = address.LongLabel.split(',');
                                                    let code_station_position=2;
                                                    if(address.Postal!=""){
                                                        code_station_position=3;
                                                        if(address.Postal==address.PlaceName){
                                                            code_station_position=2;
                                                        }
                                                    }
                                                    setAgencyState(stateCode[stateCode.length-code_station_position]);
                                                   // setAgencyState(stateCode[2]);
                                                    setCounty(address.Subregion);
                                                    

                                                }
                                               
                                            })
                                            .catch(function (error) {
                                                console.error(error);
                                            })
                                    } catch (error) {
                                        console.error(error);
                                    }

                                    if (tempGraphic) view.graphics.remove(tempGraphic);
                                    // create new graphic based on original dragging graphic
                                    let newGraphic = draggingGraphic.clone();
                                    newGraphic.geometry = tempGraphic.geometry.clone();

                                    // add replacement graphic
                                    view.graphics.add(newGraphic);

                                    // reset vars
                                    draggingGraphic = null;
                                    tempGraphic = null;
                                }                              
                            }
                        });
                        // on drag end, continue only if there is a draggingGraphic

                    }
                })

            });
    }
    const ShowErrPopUP = () => {
        setErrPopUp(false);
    };

    const handleChange = name => async event => {
        setErrMsg(null);
        let value = event.target.value;
        let longitude = long;
        let latitude = lat;
        let location = stationLocation;
        if (name == 'station_Privacy') {
            setStationPrivacy(event.target.value)
        } else if (name == 'display_name') {
            setDisplayName(event.target.value);
           
            if(value==''){
                setDisplayNameError(true)
                setFormErrorMessage('Field cannot be empty')
            }else{
                setDisplayNameError(false)
            }

           
        } else if (name == 'client_station_id') {
            if(value==''){

                setStationIdError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationIdError(false)

            }
            let _value = event.target.value;
            if (/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(event.target.value))
                _value = event.target.value.replace(/[^a-zA-Z0-9]/g, '');
            setStationId(_value);
        } else if (name == 'status_check') {
            setStatus(event.target.value)
        } else if (name == 'jurisdiction') {
            setJurisdiction(event.target.value)
        } else if (name == 'community') {
            setCommunity(event.target.value)
        } else if (name == 'speed_limit') {
            setSpeedLimit(event.target.value)
        } else if (name == 'FK_functional_classification_code') {
            setFccDropdownVal(event.target.value)
        } else if (name == 'FK_primary_purpose') {
            setPrsDropdownVal(event.target.value)
        } else if (name == 'description') {
            setDescription(event.target.value)
        } else if (name == 'seasonal_factor_group') {
            setSeasonalFG(event.target.value)
        } else if (name == 'annual_factor_group') {
            setAnnualFG(event.target.value)
        } else if (name == 'growth_factor_group') {
            setGrowthFG(event.target.value)
        } else if (name == 'year_station_established') {
            setYear(event.target.value)
        } else if (name == 'national_highway_system') {
            setNHS(event.target.value)
        } else if (name == 'FK_posted_route_signing') {
            setPrsDropdownVal(event.target.value)
        } else if (name == 'Posted_Signed_Route_Number') {
            setPRS(event.target.value)
        }
        if (name == 'station_privacy' ||
            // name == 'speed_limit' ||
            name == 'FK_functional_classification_code' ||
            name == 'FK_posted_route_signing' || name == 'year_station_established') {
            value = event.target.value ? parseInt(event.target.value) : null;
        } else if (name == 'FK_primary_purpose') {
            value = event.target.value == 'Select' ? null : event.target.value;
        } else if (name == 'national_highway_system') {
            if (event.target.value == 'true') {
                value = true;
            } else if (event.target.value == 'false') {
                value = false;
            } else {
                value = null;
            }
        } else if (name == 'latitude') {
            setLat(event.target.value);
            latitude = event.target.value;
            if(value==''){
                setStationLatitudeError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationLatitudeError(false)

            }
            await setPointer(longitude, latitude);

        } else if (name == 'longitude') {
            if(value==''){
                setStationLongitudeError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationLongitudeError(false)

            }
            setLong(event.target.value);
            longitude = event.target.value;
            await setPointer(longitude, latitude);

        } else if (name == 'station_location') {
            setStationLocation(event.target.value);
            if(value==''){
                setStationLocationError(true)
                setFormErrorMessage('Field cannot be empty')

            }else{
                setStationLocationError(false)

            }
            location = event.target.value;
        } else if (name == 'speed_limit') {
            value = event.target.value ? event.target.value : null;
        } else if (name == 'miscellaneous') {
            setMiscellaneous(event.target.value)
        } else if (name == 'posted_speed_limit') {
            setPostedSpeedLimit(value);
        } else if (name == 'FK_area_classification_id') {
            if(value === "") 
                setAreaClassError(true);
            else 
                setAreaClassError(false);
            setSelectedAreaClassification(parseInt(value));
        } else if (name == 'nb_num_lanes') {
            if(value==''){
                losDirectionsError.push("nb");     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                removefromDir("nb");
            }
            setLosNB(value);
        }else if (name == 'sb_num_lanes') {
            if(value==''){
                losDirectionsError.push("sb"); 
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                removefromDir("sb");
            }
            setLosSB(value);
        }else if (name == 'eb_num_lanes') {
            if(value==''){
                losDirectionsError.push("eb"); 
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                removefromDir("eb");
            }
            setLosEB(value);
        }else if (name == 'wb_num_lanes') {
            if(value==''){
                losDirectionsError.push("wb"); 
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                removefromDir("wb");
            }
            setLosWB(value);
        }
        else if (name == 'nb_left_turn_within_100_yards') {
            setLosNBTurn(value);
        }else if (name == 'sb_left_turn_within_100_yards') {
            setLosSBTurn(value);
        }else if (name == 'eb_left_turn_within_100_yards') {
            setLosEBTurn(value);
        }else if (name == 'wb_left_turn_within_100_yards') {
            setLosWBTurn(value);
        }else if (name == 'FK_median_type_id') {
            if(value === "") 
                setMedianTypeError(true);
            else 
                setMedianTypeError(false);
            setMedianType(parseInt(value));
        }else if (name == 'state_roadway') {
            setStateRoad(value);
        }else if (name == 'nb_exclusive_left_turn_lane') {
            setNBExclusiveLeft(value);
        }else if (name == 'sb_exclusive_left_turn_lane') {
            setSBExclusiveLeft(value);
        }else if (name == 'eb_exclusive_left_turn_lane') {
            setEBExclusiveLeft(value);
        }else if (name == 'wb_exclusive_left_turn_lane') {
            setWBExclusiveLeft(value);
        }else if (name == 'nb_exclusive_right_turn_lane') {
            setNBExclusiveRight(value)
        }else if (name == 'sb_exclusive_right_turn_lane') {
            setSBExclusiveRight(value)
        }else if (name == 'eb_exclusive_right_turn_lane') {
            setEBExclusiveRight(value)
        }else if (name == 'wb_exclusive_right_turn_lane') {
            setWBExclusiveRight(value)
        }else if (name == 'one_way_roadway') {
            setOneWayRoadway(value);
        }else if (name == 'auxiliary_lanes') {
            setAuxiliaryLanes(value);
        }
        else {
            value = event.target.value;
        }
        setValues({ ...values, [name]: value });

    }

    const removefromDir = (dir) => {
        const idx = losDirectionsError.indexOf(dir);
        if (idx > -1){
            losDirectionsError.splice(idx, 1);
        }
    }


    const setPointer = (longitude, latitude) => { //set pointer on form inputs change
        loadModules(["esri/geometry/Point", "esri/Graphic", "esri/symbols/PictureMarkerSymbol", "esri/geometry/Extent"], { css: true })
            .then(([Point, Graphic, PictureMarkerSymbol, Extent]) => {
                let path = require('../../assets/images/mapPoint.svg');
                tempMapView.graphics.removeAll();
                var point = new Point(parseFloat(longitude), parseFloat(latitude));
                let pointSymbol = {
                    type: "simple-marker",
                    style: "circle",
                    color: "#00b15e",
                    size: 20,
                    outline: {
                        color: "#3676bc",
                        width: 0.5
                    }
                }
                let symbolInt = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/marker_Intersection.png"),
                    width: "42px",
                    height: "42px",
                    yoffset: "20px"
                  };
                  let symbolMid = {
                    type: "picture-marker",  // autocasts as new PictureMarkerSymbol()
                    url: require("../../assets/icons/marker_Midblock.png"),
                    width: "42px",
                    height: "42px",
                    yoffset: "20px"
                  };
                  if (stationType==1){
                    pointSymbol=symbolMid;
                  }else{
                    pointSymbol=symbolInt;
                  }
                var pointGraphic = new Graphic(point, pointSymbol);
                let instance = axios.create();
                delete instance.defaults.headers.common['X-CSRF-TOKEN'];
                try {
                    instance({
                        method: 'GET',
                        url: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/reverseGeocode?f=pjson&featureTypes=StreetInt, StreetAddress, StreetName &location=' + `${longitude}` + ',' + `${latitude}` + '&token=' + geocodeAcccessToken

                    })

                    
                        .then(async function (response) {
                            
                            if(response.data.error){
                                setLat("");
                                setLong("");
                                setStationLocation("");
                                
                                setAgencyState("");
                            // setAgencyState(stateCode[2]);
                                setCounty("");
                                

                            }else{
                                var address = response.data.address;
                                setLat(latitude);
                                setLong(longitude);
                                setStationLocation(address.Match_addr);
                                let stateCode = address.LongLabel.split(',');
                                let code_station_position=2;
                                if(address.Postal!=""){
                                    code_station_position=3;
                                    if(address.Postal==address.PlaceName){
                                        code_station_position=2;
                                    }
                                }
                                setAgencyState(stateCode[stateCode.length-code_station_position]);
                            // setAgencyState(stateCode[2]);
                                setCounty(address.Subregion);
                                tempMapView.extent = new Extent({
                                    xmin: response.data.location.x,
                                    ymin: response.data.location.y,
                                    spatialReference: {
                                        wkid: response.data.location.spatialReference.wkid
                                    }
                                });
                                tempMapView.goTo(point);
                                tempMapView.zoom = 13;
                                

                            }
                            
                        })
                        .catch(function (error) {
                            console.error(error);
                        })
                } catch (error) {
                    console.error(error);
                }
                tempMapView.graphics.add(pointGraphic);
            })
    }

    const losDisabledFieldsValidation = (dir) => {
        if(dir !== ""){
            let val = dir.toLowerCase();
            if(val === "nb" || val === "sb") {
                setLosDisabledApproaches(["nb","sb"]);
            } else {
                setLosDisabledApproaches(["eb","wb"]);
            }
        }
    }


    const selectApproach = (e) => { //This function validates the approach dropdowns        
        setApproachError(false);
        setApproachErrorBlank(false);
        setErrMsg('');
        setMidApproachSelectOneErr(false);
        setMidApproachSelectTwoErr(false);
        setIntApproachSelectOneErr(false);
        setIntApproachSelectTwoErr(false);
        setIntApproachSelectThreeErr(false);
        setIntApproachSelectFourErr(false);

        losDisabledFieldsValidation(e.target.value);

        let getSelectElement = e.target.id;
        // console.log("getSelectElement", getSelectElement, (document.getElementById('mid_Approaches_select_2').value), document.getElementById('mid_Approaches_select_2').length);
        let selDir = null;
        let selValue = null;
        if (getSelectElement == 'intersection_Approaches_select_2') {
           
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectTwoErr(true);
            } //else {
                if (e.target.value == 'EB') {
                    selDir = "EB";
                    selValue = document.getElementById('intersection_Approaches_text_2').value;
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'NB') {
                    selDir = "NB";
                    selValue = document.getElementById('intersection_Approaches_text_2').value;
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'SB') {
                    selDir = "SB";
                    selValue = document.getElementById('intersection_Approaches_text_2').value;
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else if (e.target.value == 'WB') {
                    selDir = "WB";
                    selValue = document.getElementById('intersection_Approaches_text_2').value;
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: document.getElementById('intersection_Approaches_text_2').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachTwo: {nb_approach:''} });
                    document.getElementById('intersection_Approaches_text_2').value = '';
                }
           // }
        } else if (getSelectElement == 'intersection_Approaches_select_1') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectOneErr(true);                
            } //else {
                if (e.target.value == 'EB') {
                    selDir = "EB";
                    selValue = document.getElementById('intersection_Approaches_text_1').value;
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'NB') {
                    selDir = "NB";
                    selValue = document.getElementById('intersection_Approaches_text_1').value;
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'SB') {
                    selDir = "SB";
                    selValue = document.getElementById('intersection_Approaches_text_1').value;
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else if (e.target.value == 'WB') {
                    selDir = "WB";
                    selValue = document.getElementById('intersection_Approaches_text_1').value;
                    setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: document.getElementById('intersection_Approaches_text_1').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachOne: {eb_approach:''} });
                    document.getElementById('intersection_Approaches_text_1').value = '';                    
                }                
           // }
        } else if (getSelectElement == 'intersection_Approaches_select_3') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value || document.getElementById('intersection_Approaches_select_4').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectThreeErr(true);
            } //else {

                if (e.target.value == 'EB') {
                    selDir = "EB";
                    selValue = document.getElementById('intersection_Approaches_text_3').value;
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'NB') {
                    selDir = "NB";
                    selValue = document.getElementById('intersection_Approaches_text_3').value;
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'SB') {
                    selDir = "SB";
                    selValue = document.getElementById('intersection_Approaches_text_3').value;
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else if (e.target.value == 'WB') {
                    selDir = "WB";
                    selValue = document.getElementById('intersection_Approaches_text_3').value;
                    setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: document.getElementById('intersection_Approaches_text_3').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachThree: {sb_approach:''} });
                    document.getElementById('intersection_Approaches_text_3').value = '';
                }
           // }
        } else if (getSelectElement == 'intersection_Approaches_select_4') {
            if (e.target.value !== '' && (document.getElementById('intersection_Approaches_select_2').value == e.target.value || document.getElementById('intersection_Approaches_select_3').value == e.target.value || document.getElementById('intersection_Approaches_select_1').value == e.target.value)) {
                setApproachError(true);
                setErrMsgType('error');
                setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                setIntApproachSelectFourErr(true);
            }// else {
                if (e.target.value == 'EB') {
                    selDir = "EB";
                    selValue = document.getElementById('intersection_Approaches_text_4').value;
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'NB') {
                    selDir = "NB";
                    selValue = document.getElementById('intersection_Approaches_text_4').value;
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'SB') {
                    selDir = "SB";
                    selValue = document.getElementById('intersection_Approaches_text_4').value;
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else if (e.target.value == 'WB') {
                    selDir = "WB";
                    selValue = document.getElementById('intersection_Approaches_text_4').value;
                    setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: document.getElementById('intersection_Approaches_text_4').value } });
                } else {
                    setIntAllApproaches({ ...intAllApproaches, approachFour: {wb_approach:''} });
                    document.getElementById('intersection_Approaches_text_4').value = '';
                }

                
            //}
        } else if (getSelectElement == 'mid_Approaches_select_1' && (document.getElementById('mid_Approaches_select_2').value !== '')) {
           
            // document.getElementById('mid_Approaches_text_2').value = '';
            //document.getElementById('mid_Approaches_text_1').value = '';
            //setMidAllApproaches({ ...midAllApproaches, ...midAllApproaches.approachTwo = {} });
            
            setMidAllApproaches({...midAllApproaches,
                0:{ eb_approach: "" },
                1:{ nb_approach: "" },
                2:{ sb_approach: "" },
                3:{ swb_approach: "" },
                4:{ seb_approach: "" },
                5:{ neb_approach: "" },
                6:{ nwb_approach: "" },
                7:{ wb_approach: "" }
            });
            let changeSelect = document.getElementById('mid_Approaches_select_2');
            //
           
          setValues({...values,"eb_approach":"","wb_approach":"","nb_approach":"","sb_approach":""})
            if (e.target.value === 'EB') {
                changeSelect.value="WB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "eb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "wb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({ 
                    approachOne: { eb_approach: document.getElementById('mid_Approaches_text_1').value },
                    approachTwo: { wb_approach: document.getElementById('mid_Approaches_text_2').value } });
                

                
            } else if (e.target.value == 'WB') {
                changeSelect.value="EB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "wb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "eb_approach":document.getElementById('mid_Approaches_text_2').value})
                
                setMidAllApproaches({ 
                    approachOne: { wb_approach: document.getElementById('mid_Approaches_text_1').value },
                    approachTwo: { eb_approach: document.getElementById('mid_Approaches_text_2').value } });
                
               
            } else if (e.target.value == 'NB') {
                changeSelect.value="SB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "nb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "sb_approach":document.getElementById('mid_Approaches_text_2').value})
                setMidAllApproaches({  approachOne: { nb_approach: document.getElementById('mid_Approaches_text_1').value },
                approachTwo: { sb_approach: document.getElementById('mid_Approaches_text_2').value } });
                
                
            } else if (e.target.value == 'SB') {
                changeSelect.value="NB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "sb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "nb_approach":document.getElementById('mid_Approaches_text_2').value})

                setMidAllApproaches({ 
                    approachOne: { sb_approach: document.getElementById('mid_Approaches_text_1').value },
                    approachTwo: { nb_approach:document.getElementById('mid_Approaches_text_2').value } });
                
                
            } 
        } else if (getSelectElement == 'mid_Approaches_select_2' && (document.getElementById('mid_Approaches_select_1').value !== '')) {
            
            //document.getElementById('mid_Approaches_text_1').value = '';
            setMidAllApproaches({
                0:{ eb_approach: "" },
                1:{ nb_approach: "" },
                2:{ sb_approach: "" },
                3:{ swb_approach: "" },
                4:{ seb_approach: "" },
                5:{ neb_approach: "" },
                6:{ nwb_approach: "" },
                7:{ wb_approach: "" }
            });
            
            let changeSelect = document.getElementById('mid_Approaches_select_1');
            setMidAllApproaches({ approachOne: {}, approachTwo: {} });
            

            if (e.target.value == 'EB') {
                changeSelect.value="WB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "eb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "wb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({  
                                        approachOne: { eb_approach: document.getElementById('mid_Approaches_text_2').value },
                                        approachTwo: { wb_approach: document.getElementById('mid_Approaches_text_1').value } });
                

            } else if (e.target.value == 'WB') {
                changeSelect.value="EB";
                setValues({...values,
                    "nb_approach":"","sb_approach":"",
                    "wb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "eb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({  
                    approachOne: { wb_approach: document.getElementById('mid_Approaches_text_2').value },
                    approachTwo: { eb_approach: document.getElementById('mid_Approaches_text_1').value } 
                 });
                
                
            } else if (e.target.value == 'NB') {
                changeSelect.value="SB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "nb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "sb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({ 
                    approachOne: { nb_approach: document.getElementById('mid_Approaches_text_2').value },
                    approachTwo: { sb_approach: document.getElementById('mid_Approaches_text_1').value } });
                
            } else if (e.target.value == 'SB') {
                changeSelect.value="NB";
                setValues({...values,
                    "eb_approach":"","wb_approach":"",
                    "sb_approach":document.getElementById('mid_Approaches_text_1').value,
                    "nb_approach":document.getElementById('mid_Approaches_text_2').value})
                    
                setMidAllApproaches({ 
                    approachOne: { sb_approach: document.getElementById('mid_Approaches_text_2').value },
                    approachTwo: { nb_approach: document.getElementById('mid_Approaches_text_1').value }
                 });
                
            } else if (e.target.value == '') {                             
                /*document.getElementById('mid_Approaches_text_2').value = '';                
                setMidAllApproaches({ ...midAllApproaches, approachTwo: {} });                
                let tmpValue = changeSelect.value;
                changeSelect.innerHTML = '';
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);
                changeSelect.value = tmpValue*/
            } else if (e.target.value == "null") {                
                /*document.getElementById('mid_Approaches_text_2').value = '';
                setMidAllApproaches({ ...midAllApproaches, approachTwo: {} });
                let opt1 = document.createElement('option');
                opt1.value = '';
                opt1.innerHTML = 'Select';
                changeSelect.appendChild(opt1);
                let opt2 = document.createElement('option');
                opt2.value = 'EB';
                opt2.innerHTML = 'EB';
                changeSelect.appendChild(opt2);
                let opt3 = document.createElement('option');
                opt3.value = 'NB';
                opt3.innerHTML = 'NB';
                changeSelect.appendChild(opt3);
                let opt4 = document.createElement('option');
                opt4.value = 'SB';
                opt4.innerHTML = 'SB';
                changeSelect.appendChild(opt4);
                let opt5 = document.createElement('option');
                opt5.value = 'WB';
                opt5.innerHTML = 'WB';
                changeSelect.appendChild(opt5);*/
            }
        }

        let tmp = approachesForLane;
        tmp.forEach(function (it, ind) {
            if(selDir === "NB" && it.nb_approach) {
                tmp[ind]['nb_approach'] = selValue;
            } else if(selDir === "EB" && it.eb_approach) {
                tmp[ind]['eb_approach'] = selValue;
            } else if(selDir === "SB" && it.sb_approach) {
                tmp[ind]['sb_approach'] = selValue;
            } else if(selDir === "WB" && it.wb_approach) {
                tmp[ind]['wb_approach'] = selValue;
            }
        });
        setApproachesForLane(tmp);

    }


    const approachText = (e) => {
        setErr({});
        setApproachError(false);
        let value= e.target.value.trim() 
        let getTextElement = e.target.id;
        let selDir = null;
        if (getTextElement == 'intersection_Approaches_text_1') {
            if(value==''){
                aproachDetailsError[0]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                aproachDetailsError[0]=false
               
            }
            
            if (document.getElementById('intersection_Approaches_select_1').value == 'EB') {
                selDir = "EB";
                setIntAllApproaches({ ...intAllApproaches, approachOne: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'NB') {
                selDir = "NB";
                setIntAllApproaches({ ...intAllApproaches, approachOne: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'SB') {
                selDir = "SB";
                setIntAllApproaches({ ...intAllApproaches, approachOne: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_1').value == 'WB') {
                selDir = "WB";
                setIntAllApproaches({ ...intAllApproaches, approachOne: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'intersection_Approaches_text_2') {
            if(value==''){
                
                aproachDetailsError[1]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[1]=false
            }   
           
            if (document.getElementById('intersection_Approaches_select_2').value == 'EB') {
                selDir = "EB";
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'NB') {
                selDir = "NB";
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'SB') {
                selDir = "SB";
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_2').value == 'WB') {
                selDir = "WB";
                setIntAllApproaches({ ...intAllApproaches, approachTwo: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'intersection_Approaches_text_3') {
            if(value==''){
                
                aproachDetailsError[2]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[2]=false
            }
            if (document.getElementById('intersection_Approaches_select_3').value == 'EB') {
                selDir = "EB";
                setIntAllApproaches({ ...intAllApproaches, approachThree: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'NB') {
                selDir = "NB";
                setIntAllApproaches({ ...intAllApproaches, approachThree: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'SB') {
                selDir = "SB";
                setIntAllApproaches({ ...intAllApproaches, approachThree: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_3').value == 'WB') {
                selDir = "WB";
                setIntAllApproaches({ ...intAllApproaches, approachThree: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'intersection_Approaches_text_4') {
            if(value==''){
                
                aproachDetailsError[3]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[3]=false
            }
            if (document.getElementById('intersection_Approaches_select_4').value == 'EB') {
                selDir = "EB";
                setIntAllApproaches({ ...intAllApproaches, approachFour: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'NB') {
                selDir = "NB";
                setIntAllApproaches({ ...intAllApproaches, approachFour: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'SB') {
                selDir = "SB";
                setIntAllApproaches({ ...intAllApproaches, approachFour: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('intersection_Approaches_select_4').value == 'WB') {
                selDir = "WB";
                setIntAllApproaches({ ...intAllApproaches, approachFour: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'mid_Approaches_text_2') {
            if(value==''){
                
                aproachDetailsError[1]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[1]=false
            }
            if (document.getElementById('mid_Approaches_select_2').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_2').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachTwo: { wb_approach: e.target.value.trim() } });
            }
        } else if (getTextElement == 'mid_Approaches_text_1') {
            if(value==''){
                
                aproachDetailsError[0]=true     
                setFormErrorMessage('Field Field cannot be empty')
            }else{
                
                aproachDetailsError[0]=false
            }
            if (document.getElementById('mid_Approaches_select_1').value == 'EB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { eb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'NB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { nb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'SB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { sb_approach: e.target.value.trim() } });
            } else if (document.getElementById('mid_Approaches_select_1').value == 'WB') {
                setMidAllApproaches({ ...midAllApproaches, approachOne: { wb_approach: e.target.value.trim() } });
            }
        }

        let tmp = approachesForLane;
        tmp.forEach(function (it, ind) {
            if(selDir === "NB" && it.nb_approach) {
                tmp[ind]['nb_approach'] = value;
            } else if(selDir === "EB" && it.eb_approach) {
                tmp[ind]['eb_approach'] = value;
            } else if(selDir === "SB" && it.sb_approach) {
                tmp[ind]['sb_approach'] = value;
            } else if(selDir === "WB" && it.wb_approach) {
                tmp[ind]['wb_approach'] = value;
            }
        });
        setApproachesForLane(tmp);
    }

    const validateForm = async e => {
        e.preventDefault();
        //validate if    
        try {
            axios({
                method: 'post',
            
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.stationHasData + `${sessionStorage.getItem('viewStationId')}`,

            })
            .then(async function (response) {
                if (response.status && response.status == '200') {
                    
                    //enableFlag true  means this station is editable
                    //
                    let hasData=response.data.data;
                    if(getEnableFlag  && hasData){
                        setErrMsgType('error')
                        setErrMsg("Unable to edit a station that contains data");
                        setErrPopUp(true)
                        setLoader(false);
                    }else{
                        setErrMsg(null);
                        if (values.station_type == 0 &&
                            values.station_location == '' &&
                            values.client_station_id == '' &&
                            values.latitude == '' &&
                            values.longitude == '') {
                            setErrMsg('All mandatory fields are required');
                            setErrPopUp(true);
                        } else if (values.station_type == 0) {
                            setErrMsg('Station type required');
                            setErrPopUp(true);
                        } else if (stationLocation == undefined || stationLocation == '') {
                            setErrMsg('Location required');
                            setErrPopUp(true);
                        } else if (values.client_station_id == '') {
                            setErrMsg('Station ID required.');
                            setErrPopUp(true);
                        } else if (values.client_station_id.length > 20) {
                            setErrMsg('Station ID can be at most 20 characters.');
                            setErrPopUp(true);
                        } else if (values.latitude == '' || isNaN(values.latitude)) {
                            setErrMsg('Latitude required.');
                            setErrPopUp(true);
                        } else if (values.longitude == '' || isNaN(values.longitude)) {
                            setErrMsg('Longitude required.');
                            setErrPopUp(true);
                        } else if (values.speed_limit !== null && isNaN(values.speed_limit)) {
                            setErrMsg('Speed Limit Must Be Integer.');
                            setErrPopUp(true);
                        }
                        else {
                            let flagUpdateStation=true;
                            let newData;
                            if (resetForm == false) { //reseting approaches values
                                newData = { ...values, station_location: stationLocation, latitude: lat, longitude: long, state_code: agencyState, fips_county_code: county };
                            
                                if (newData.station_type == 2) {
                                    let keys = Object.keys(intAllApproaches);
                                    // let keys = Object.keys(initialApproaches);

                                    for (var i = 0; i < keys.length; i++) {
                                        var key = (keys[i]);
                                        newData = { ...newData, ...intAllApproaches[key] }
                                    }
                                        //validate if aproach has values duplicates
                                    var aproach1=document.getElementById('intersection_Approaches_select_1').value;
                                    var aproach2=document.getElementById('intersection_Approaches_select_2').value;
                                    var aproach3=document.getElementById('intersection_Approaches_select_3').value;
                                    var aproach4=document.getElementById('intersection_Approaches_select_4').value;                                    
                                    
                                    if(hasDuplicated([aproach1,aproach2,aproach3,aproach4].filter(aprc => aprc !=''))){
                                        setApproachError(true);
                                        flagUpdateStation=false;
                                        setErrMsg('Stations cannot have multiple entries for the same approach direction.');
                                    }
                                } else if (newData.station_type == 1) {                                    
                                    let keys = Object.keys(midAllApproaches);
                                    for (var i = 0; i < keys.length; i++) {
                                        var key = (keys[i]);
                                    
                                        newData = { ...newData, ...midAllApproaches[key] }

                                    }
                                        //validate if aproach has values duplicates
                                    var aproach1=document.getElementById('mid_Approaches_select_1').value;
                                    var aproach2=document.getElementById('mid_Approaches_select_2').value;
                            
                                    if(hasDuplicated([aproach1,aproach2])){
                                        setApproachError(true);
                                        flagUpdateStation=false;
                                    }
                                    newData.enable_los_calculation = losEnabled;
                                    if(losEnabled) {
                                        if (!newData.posted_speed_limit) {
                                            setErrMsg('Posted speed limit must be integer.');
                                            setErrPopUp(true);
                                            return 
                                        }
                                        if(!newData.FK_area_classification_id) {
                                            setAreaClassError(true);
                                            return;
                                        }
                                        if(!newData.FK_median_type_id) {
                                            setMedianTypeError(true);
                                            return;
                                        }
                                        if(losDisabledApproaches.length > 0) {
                                            for(const it of losDisabledApproaches) {
                                                if(newData[`${it}_num_lanes`] === "" || !newData[`${it}_num_lanes`]) {
                                                    losDirectionsError.push(it);
                                                    // setErrMsg('All mandatory fields are required');
                                                    // setErrPopUp(true);
                                                    return
                                                } else {
                                                    removefromDir(it);
                                                }
                                            }
                                        }
                                    }
                                }
                            } else {
                                newData = { ...values, station_location: stationLocation, latitude: lat, longitude: long, state_code: agencyState, fips_county_code: county };
                                
                            }
                            if (validateApproches(newData)) {                                
                                setErrMsg('Station approaches with assigned directions cannot be blank.');
                                setErrPopUp(true);
                                setErr(newData);
                                setApproachErrorBlank(true);
                                setErrMsgType('error');
                                flagUpdateStation=false;                                
                            }

                            if (validateApprochesOneAdded(newData)) {                                
                                setErrMsg('Please fill in at least one approach.');
                                setErrPopUp(true);
                                setErr(newData);
                                setApproachErrorBlank(true);
                                setErrMsgType('error');
                                flagUpdateStation=false;                                
                            } 

                            if (flagUpdateStation){
                                updateStation(newData);
                            }

                        }
                    }

                }
            })
            .catch(function (error) {
                if (error.response) {
                    setErrMsgType('error')
                    setErrMsg(error.response.data.message);
                    setErrPopUp(true)
                    setLoader(false);
                } else {
                    setErrMsgType('error')
                    setErrMsg('Something went wrong.');
                    setErrPopUp(true)
                    setLoader(false);
                }
            })
        } catch (error) {
            setLoader(false);
        }
    }
    function hasDuplicated(arr){
        return arr.some(function(v,i) { return arr.indexOf(v,i+1)>-1 })

    }

    //This method is use for validate the approches  ... start

    function validateApproches(newData) {        
      if(newData.station_type_name === "Midblock"){
          let validateArray= [];          
          validateArray.push(newData.eb_approach,newData.wb_approach,newData.nb_approach,newData.sb_approach);
          var filterVal =  validateArray.filter((key,keyindex)=> key && key !== ""
        )
        
          if((filterVal.length == 0) || (filterVal.length == 1) || (filterVal.length > 2)){
            return true;
          }else{
            return false;
          }
      }else{
        var aproach1=document.getElementById('intersection_Approaches_select_1').value;
        var aproach2=document.getElementById('intersection_Approaches_select_2').value;
        var aproach3=document.getElementById('intersection_Approaches_select_3').value;
        var aproach4=document.getElementById('intersection_Approaches_select_4').value;

        var aproachtext1=document.getElementById('intersection_Approaches_text_1').value.trim();
        var aproachtext2=document.getElementById('intersection_Approaches_text_2').value.trim();
        var aproachtext3=document.getElementById('intersection_Approaches_text_3').value.trim();
        var aproachtext4=document.getElementById('intersection_Approaches_text_4').value.trim();        

        if((aproach1 != '' && aproachtext1 =='') || (aproach2 != '' && aproachtext2 =='') || (aproach3 != '' && aproachtext3 =='') || (aproach4 != '' && aproachtext4 =='')){
            return true;
        }else{
            return false;
        }
      }
    }
    function validateApprochesOneAdded(newData) {        
          var aproach1=document.getElementById('intersection_Approaches_select_1').value;
          var aproach2=document.getElementById('intersection_Approaches_select_2').value;
          var aproach3=document.getElementById('intersection_Approaches_select_3').value;
          var aproach4=document.getElementById('intersection_Approaches_select_4').value;  
          var aproachtext1=document.getElementById('intersection_Approaches_text_1').value.trim();
          var aproachtext2=document.getElementById('intersection_Approaches_text_2').value.trim();
          var aproachtext3=document.getElementById('intersection_Approaches_text_3').value.trim();
          var aproachtext4=document.getElementById('intersection_Approaches_text_4').value.trim();        
  
          if((aproach1 == '' && aproachtext1 =='') && (aproach2 == '' && aproachtext2 =='') && (aproach3 == '' && aproachtext3 =='') && (aproach4 == '' && aproachtext4 =='')){
              return true;
          }else{
              return false;
          }
        
      }
    //This method is use for validate the approches  ... end

    //This method is use for API call to update station ... start
    const updateStation = (newData) => {
        setLoader(true);
        try {
            axios({
                method: 'post',
                data: newData,
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.stationUpdateAPI + `${sessionStorage.getItem('viewStationId')}`,
               

            })
                .then(async function (response) {
                  
                    if (response.status && response.status == 200) {
                        
                        //props.stationtabBack();
                        setErrMsgType('custom_success')
                        setErrMsg('Saved successfully');
                        updateList(false)
                        setErrPopUp(true)
                        setLoader(false);
                        newData['station_id'] = sessionStorage.getItem('viewStationId')
                        updateStationDetails(newData);

                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error')
                        setErrMsg(error.response.data.message);
                        setErrPopUp(true)
                        setLoader(false);
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                        setLoader(false);
                    }
                })
        } catch (error) {
            setLoader(false);
        }
    }

    const handleScroll = () => {
        if (mainBgRef.current) {
          const { scrollTop } = mainBgRef.current;
        
          if (scrollTop > 0) {
            setScrolled(true);
          } else {
            setScrolled(false);
          }
        }
     }; 

    return (

        <React.Fragment>  
        <CssBaseline />
            <div className="management-main">
                <Container className="management-container" maxWidth="lg">
                <form noValidate autoComplete="off" onSubmit={e => validateForm(e)} data-testid='station_details_form'>    
                     
                    <AppBar position="static" color="default" className={(scrolled?'table-scrolled':'') + ' tabs-header station-tabs' }>
                        <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        aria-label="full width tabs example"
                        >
                            <Tab label="Edit station" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={'main_panel_title'}  style={{ maxWidth:'110px !important'}}/>
                            
                        </Tabs>
                        <div className="add-user-cnt">
                           
                            <img src={require('../../assets/icons/close.svg')} onClick={() => props.setShowStationDetails(false)} />
                        </div>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                        className={'main_bg'}
                      
                    >
                        <TabPanel value={value} index={0} dir={theme.direction}  >
                      
                        <div>
                        <div className="stations-detail-content ddd"
                         onScroll={handleScroll}
                         ref={mainBgRef}
                         >
  {errMsg ? <div className={'approachError'} >  <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                            <div className={'station_container'}  
                           >
                              
                                <div className={'station_container_row'}>
                                    <div className="station_card_info m-r-16" style={{marginTop:'16px'}}>
                                        <div className={'station_card_title'}>
                                        General Info  
                                        </div>
                                        <div className={'station_card_content'}>
                                            <div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>Station type </label>
                                                            {!getEnableFlag ? <select id="station_Type" name="station_Type" className={'general-text-input'} onChange={showInterractionApproches} disabled={true} style={{ backgroundColor: '#F2F2F2' }} data-testid='station_type'>
                                                                <option value={stationType} selected={true}>{stationTypeName}</option>
                                                            </select> :
                                                            <select id="station_Type" name="station_type" data-testid='station_type' className={'general-text-input'} onChange={showInterractionApproches} defaultValue={stationType}>
                                                                <option value="">Select</option>
                                                                {stationTypeValue.length > 0 &&
                                                                    stationTypeValue.map((value, index) => {
                                                                        return <option selected={value.id == stationType} value={value.id}>{value.station_type}</option>
                                                                    })

                                                                }
                                                            </select>}
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Station privacy</label>
                                                            <select id="station_Privacy" 
                                                            name="station_Privacy" 
                                                            className={'general-text-input'} 
                                                            onChange={handleChange('station_privacy')} 
                                                            data-testid='station_privacy'>
                                                                <option value={1} selected={stationPrivacy == 1 ? true : false}>Public</option>
                                                                <option value={2} selected={stationPrivacy == 2 ? true : false}>Private</option>
                                                            </select>

                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Station location </label>
                                                        <FilledInput id="station_Location" 
                                                        name="station_Location" 
                                                        className={stationLocationError ? "form-text-input-error" : "form-text-input"} 
                                                        variant="outlined" 
                                                        style={{width:'448px'}} 
                                                        type="text" 
                                                        value={stationLocation} 
                                                        required data-testid='station_location' 
                                                        endAdornment={ stationLocationError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                        onChange={handleChange('station_location')} />
                                                          {stationLocationError ? <p className="form-error-label">{formErrorMessage}</p> : null}

                                                    </div>
                                                  
                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child'>
                                                        <label  className={'general-label label_input_station'}>Station name</label>
                                                        <FilledInput id="display_Name" 
                                                        name="display_name" 
                                                        data-testid='display_name' 
                                                        className={displayNameError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ displayNameError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                        value={displayName}
                                                        style={{width:'448px'}} 
                                                       
                                                        type="text" variant="outlined" 
                                                        onChange={handleChange('display_name')} />
                                                         {displayNameError ? <p className="form-error-label">{formErrorMessage}</p> : null}


                                                        
                                                        </div>
                                                    </div>
                                        
                                                </div>
                                               
                                                
                                        
                                        </div>

                                    </div>
                                    <div className="station_card_info_right"  style={{marginTop:'16px'}}>
                                        <div className={'station_card_title'}>
                                        Map 
                                        </div>
                                        <div className={'station_card_content_right'} style={{height: '278px'}}>
                                            <div>
                                              
                                            <div className={classes.locationMapView}>
                                                    <div ref={mapRef} className={classes.mapContainer} data-testid='mapView'>
                                                        <Box display='flex' flexDirection="column" className={classes.iconBox}>
                                                            <div className={'homeIcon'} title="Home" >
                                                            <img src={require('../../assets/icons/map/Home.png')} style={{width:'20px', height:'20px'}} onClick={() => homeEvent()} title="Home" />
                                                                
                                                            </div>
                                                            <div className={'zoomIcon'} style={{ marginBottom: '-3px' }} title="Zoom In">
                                                            <img src={require('../../assets/icons/map/Add.png')}  style={{width:'20px', height:'20px'}} onClick={() => ZoomInEvent()} title="Zoom In" />
                                                               
                                                            </div>
                                                            <div className={'inIcon'} title="Zoom Out">
                                                            <img src={require('../../assets/icons/map/Minus.png')}   style={{width:'20px', height:'20px'}} onClick={() => zoomOutEvent()} title="Zoom Out"/>
                                                               
                                                            </div>
                                                            {/* This Code Just Information to click    */}
                                                            <div className={'r-click-map-edit'}>Left-click to drag pin to new location </div>
                                                            {/* This Code Just Information to click    */}
                                                        </Box>
                                                    </div>
                                                </div>
                                            </div>
                                        
                                        </div>

                                    </div>

                                </div>

                                <div className={'station_container_row'}>
                                    <div className="station_card_info m-r-16">
                                        <div className={'station_card_title'}>
                                        Details & location 
                                        </div>
                                        <div className={'station_card_content'} style={{minHeight: '328px'}}>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child  m-r-16'>
                                                        <label className={'general-label label_input_station'}>Station ID</label>
                                                        <FilledInput id="station_id" 
                                                        name="client_station_id" 
                                                        data-testid='client_station_id'
                                                        type="text" 
                                                        variant="outlined" 
                                                        required 
                                                        value={stationId} 
                                                        className={stationIdError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationIdError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                        onChange={handleChange('client_station_id')} />
                                                          {stationIdError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Status</label>
                                                        <select 
                                                        id="status_check" 
                                                        name="status_check" 
                                                        data-testid='status' 
                                                        className={'general-text-input'} 
                                                        onChange={handleChange('status')}>
                                                            <option value="active" selected={status == 'active' ? true : false}>Active</option>
                                                            <option value="inactive" selected={status == 'inactive' ? true : false}>Inactive</option>
                                                        </select>

                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'} >Latitude</label>
                                                        <FilledInput 
                                                        id="latitude" 
                                                        name="latitude" 
                                                        disabled
                                                        data-testid='latitude' 
                                                        className={stationLatitudeError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationLatitudeError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                      
                                                        type="text" variant="outlined" 
                                                        value={lat!=""?parseFloat(lat).toFixed(6):""} 
                                                        required onChange={handleChange('latitude')} />
                                                         {stationLatitudeError ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <label className={'general-label label_input_station'}>Longitude</label>
                                                        <FilledInput 
                                                        id="longitude" 
                                                        name="longitude" 
                                                        disabled
                                                        data-testid='longitude' 
                                                        className={stationLongitudeError ? "form-text-input-error" : "form-text-input"} 
                                                        endAdornment={ stationLongitudeError && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                        
                                                       
                                                        type="text" 
                                                        variant="outlined" 
                                                        value={long!=""?parseFloat(long).toFixed(6):""} 
                                                        required onChange={handleChange('longitude')} />
                                                         {stationLongitudeError ? <p className="form-error-label">{formErrorMessage}</p> : null}

                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>State</label>
                                                        <TextField 
                                                        id="state_code" 
                                                        name="state_code" 
                                                        style={{width:'48px'}}  
                                                        data-testid='state_code' 
                                                        className={'form-text-input'} 
                                                         type="text" variant="outlined" value={agencyState} required disabled={true} />
                                                    </div>
                                                    <div className='station-detail-child m-r-16'>
                                                        <label className={'general-label label_input_station'}>County</label>
                                                        <TextField id="county" name="fips_county_code" style={{width:'216px'}}   
                                                        data-testid="fips_county_code" className={'general-text-input txt-gray-700'}  type="text" variant="outlined" value={county} disabled={true} />
                                                    </div>
                                                    <div className='station-detail-child'>
                                                    <div className='optional-cnt'>
                                                            <label className={'general-label label_input_station'}>Speed limit</label>
                                                            <span class="station-text1">Optional</span>
                                                        </div>
                                                        <TextField id="speed_Limit" 
                                                        name="speed_Limit" 
                                                        style={{width:'152px'}}  
                                                        data-testid="speed_limit" 
                                                        className={'general-text-input txt-gray-700'}  type="tel" variant="outlined" required value={speedLimit} onChange={handleChange('speed_limit')} />
                                                        
                                                    </div>
                                                

                                                </div>
                                                <div className='station-detail-row'>
                                                    <div className='station-detail-child m-r-16'>
                                                        <div className='optional-cnt'>
                                                            <label className={'general-label'}>Jurisdiction</label>
                                                            <span class="station-text1">Optional</span>
                                                        </div>
                                                        <TextField id="jurisdiction" 
                                                        name="jurisdiction" 
                                                        data-testid="jurisdiction"
                                                        className={'general-text-input'} 
                                                      
                                                        type="text" 
                                                        variant="outlined" 
                                                        value={jurisdiction} onChange={handleChange('jurisdiction')}/>
                                                    
                                                    </div>
                                                    <div className='station-detail-child'>
                                                        <div className='optional-cnt'>
                                                            <label className={'general-label'}>Community</label>
                                                            <span class="station-text1">Optional</span>
                                                        </div>
                                                        <TextField id="community" name="community" data-testid="community" className={'general-text-input txt-gray-700'}  type="text" variant="outlined" required value={community} onChange={handleChange('community')} />             
                                                    </div>
                                                

                                                </div>
                                                
                                            <div>
                                        
                                            </div>
                                        
                                        </div>
                                        <div className='pnl-main-miscellaneous'>
                                            <label>Miscellaneous</label>
                                            <div className='pnl-main-miscellaneous-card'>
                                                <textarea onChange={handleChange('miscellaneous')} value={miscellaneous} ></textarea>                    
                                            </div>
                                        </div>

                                    </div>
                                    <div className="station_card_info_right">
                                        <div className={'station_card_title'}>
                                        Approaches 
                                        </div>
                                        <div className={'station_card_content'}  >
                                            <div>
                                            {
                                            approaches.length > 0 ?
                                            <>
                                            
                                                <div className={stationType == 2 ? 'hideMidBlock' : 'showMidBlock'}>
                                                        
                                                        
                                                        {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /></div> : null}
                                                        <div className={classes.interApprochMainBlock}>
                                                        <div className='station-detail-row'>
                                                    
                                                            <div className="station-detail-childt  m-r-16" >
                                                                <label className={'general-label label_input_station'}>Direction</label>
                                                                <select id="mid_Approaches_select_1" 
                                                                    name="mid_Approaches_select_1" 
                                                                    data-testid="mid_Approaches_select_1" 
                                                                    className={' general-text-input' } 
                                                                    disabled={!getEnableFlag || stationHasData ? true : false}
                                                                    style={{width:'88px'}}
                                                                    onChange={selectApproach}>
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                </select>
                                                            </div>
                                                            <div className="station-detail-childt  m-r-16">
                                                            <label className={'general-label  label_input_station'}>Details</label>
                                                                <FilledInput
                                                                 id="mid_Approaches_text_1" 
                                                                name="mid_Approaches_text_1" 
                                                                style={{width:'336px'}} 
                                                                className={aproachDetailsError[0] ? "form-text-input-error" : "form-text-input"} 
                                                                endAdornment={ aproachDetailsError[0] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                                      
                                                                type="text" 
                                                                variant="outlined" 
                                                                onChange={approachText} 
                                                                data-testid="mid_Approaches_text_1" />
                                                                 {aproachDetailsError[0] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                {midApproachSelectOneErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                            </div>
                                                            </div>    
                                                        </div>
                                                        <div className={classes.interApprochMainBlock}>
                                                            <div className='station-detail-row'>    
                                                                <div className="station-detail-childt  m-r-16">
                                                                <label className={'general-label label_input_station'}>Direction</label>
                                                                    <select id="mid_Approaches_select_2" 
                                                                            name="mid_Approaches_select_2" 
                                                                            className={' general-text-input select-ap'} 
                                                                            onChange={selectApproach}
                                                                            disabled={!getEnableFlag ? true : null} 
                                                                            style={{width:'88px'}}
                                                                            data-testid="mid_Approaches_select_2">
                                                                        <option value="">Select</option>
                                                                        <option value="EB">EB</option>
                                                                        <option value="NB">NB</option>
                                                                        <option value="SB">SB</option>
                                                                        <option value="WB">WB</option>
                                                                    </select>
                                                                </div>
                                                                <div className="station-detail-childt  m-r-16">
                                                                <label className={'general-label  label_input_station'}>Details</label>
                                                                    <FilledInput id="mid_Approaches_text_2" 
                                                                    name="mid_Approaches_text_2" 
                                                                    style={{width:'336px'}}
                                                                    className={aproachDetailsError[1] ? "form-text-input-error" : "form-text-input"} 
                                                                    endAdornment={ aproachDetailsError[1] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                 
                                                                    type="text" variant="outlined" 
                                                                    onChange={approachText} 
                                                                    data-testid="mid_Approaches_text_2" />
                                                                    {aproachDetailsError[1] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                    {midApproachSelectTwoErr ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    
                                                            
                                                        </div>
                                                        {/* -------------------------------------------------- */}
                                                        <div className={stationType == 1 ? 'hideInteraction' : 'showHideInteraction'}>
                                                    
                                                        
                                                                
                                                                {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /> </div> : null}
                                                                {approachErrorBlank ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachErrorBlank} msgType={errMsgType} /> </div> : null}
                                                                
                                                                {                                                                
                                                                    approaches.map((value, index) => {                                                                    
                                                                        let indexApproaches = {eb_approach:1,nb_approach:2,sb_approach:3,wb_approach:4};
                                                                        let objVal = Object.values(value);
                                                                        let objKey = Object.keys(value);
                                                                        //if(objVal[0] != ""){
                                                                            return (<div className={classes.interApprochMainBlock}>

                                                            <div className='station-detail-row'>    
                                                                <div className="station-detail-childt">
                                                                <label className={'general-label  label_input_station'}>Direction</label>
                                                                                    <select id={'intersection_Approaches_select_' + [indexApproaches[objKey[0]]]} 
                                                                                        name={'intersection_Approaches_select_' + [indexApproaches[objKey[0]]]} 
                                                                                        className={' general-text-input select-ap'}  
                                                                                        style={{width:'88px'}}
                                                                                        
                                                                                        IconComponent={ExpandMoreIcon}
                                                                                        onChange={selectApproach} 
                                                                                        disabled={!getEnableFlag || stationHasData? true : false}
                                                                                        data-testid={'intersection_Approaches_select_' + [indexApproaches[objKey[0]]]} >
                                                                                        <option value="" selected={(objVal[0] =="")?true:false}>Select</option>
                                                                                        <option value="EB" selected={(objKey[0] == 'eb_approach' && objVal[0] !="")?true:false}>EB</option>
                                                                                        <option value="WB" selected={(objKey[0] == 'wb_approach' && objVal[0] !="")?true:false}>WB</option> 
                                                                                        <option value="NB" selected={(objKey[0] == 'nb_approach' && objVal[0] !="")?true:false}>NB</option>
                                                                                        <option value="SB" selected={(objKey[0] == 'sb_approach' && objVal[0] !="")?true:false}>SB</option>
                                                                                    
                                                                                    </select>
                                                                   
                                                                </div>
                                                                <div className="station-detail-childt">
                                                                <label className={'general-label  label_input_station'}>Details</label>
                                                                                    <FilledInput error={getErr.eb_approach == ""} 
                                                                                        id={"intersection_Approaches_text_" + [indexApproaches[objKey[0]]]} 
                                                                                        name={"intersection_Approaches_text_" + [indexApproaches[objKey[0]]]} 
                                                                                     
                                                                                        className={aproachDetailsError[indexApproaches[objKey[0]]-1] ? "form-text-input-error" : "form-text-input"} 
                                                                                        endAdornment={ aproachDetailsError[indexApproaches[objKey[0]]-1] && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                                        
                                                                                        type="text" 
                                                                                        variant="outlined" 
                                                                                        defaultValue={objVal[0]} 
                                                                                        style={{width:'336px'}}
                                                                                        disabled={objVal[0] == '' && stationHasData? true : false}
                                                                                        onChange={approachText} 
                                                                                        data-testid={"intersection_Approaches_text_" + [indexApproaches[objKey[0]]]} />
                                                                                         {aproachDetailsError[indexApproaches[objKey[0]]-1] ? <p className="form-error-label">{formErrorMessage}</p> : null}
                                                                                    {getErr.eb_approach == "" && <FontAwesomeIcon icon={faExclamationCircle}  className={classes.errIcon}/>}
                                                                   
                                                                </div>
                                                            </div>
                                                                               
                                                                                
                                                                            </div>)
                                                                        //}                                                                
                                                                    })                                                                                                                               
                                                                }
                                                                {/* Additional Approcesh block */}
                                                            
                                                        </div>

                                                        </>
                                            
                                                : null
                                        }
                                            </div>
                                        
                                        </div>
                                        {
                                            stationType === 2 &&
                                            <div className='pnl-main-lane'>
                                                <label>Lane geometry</label>
                                                <div className='pnl-main-lane-card'>
                                                    <label>Configure this stations lane geometry using our geometry configurator by pressing the button below.</label>
                                                    <div>
                                                        <div className={laneConfigId ? 'geometry-cnt geometry-set' : 'geometry-cnt no-geometry-set'}>
                                                            <label className='geometry-set-indicator'></label>
                                                            <label>{laneConfigId ? 'Geometry set': 'No geometry set'}</label>
                                                        </div>
                                                        <div className="geometry-link" onClick={() => setShowLaneConfig(true)}>
                                                            <label>Lane geometry configurator</label>
                                                            <img src={require('../../assets/icons/external_link.svg')} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            stationType == 1 &&
                                            <div className="station_card_info m-r-16">
                                            <div className={'station_card_title'}>
                                                <Checkbox checked={losEnabled} onChange={() => setLosEnabled(!losEnabled)} />Enable Level of Service (LOS) calculations 
                                            </div>
                                            {
                                                losEnabled &&
                                                <div className={'station_card_content_right'}>
                                                    {!losEnabled && (<div style={{position:'absolute', top:0, left:0, width:'100%', height: '100%', backgroundColor:'rgba(0, 0, 0, 0.03)', pointerEvents:'none',zIndex:1}}></div> )}
                                                    <div>
                                                    <div className={midBlockApproch}>
                                                            {approachError ? <div className={classes.approachError}> <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={approachError} msgType={errMsgType} /></div> : null}
                                                            <div className={classes.interApprochMainBlock}>
                                                            <div className='station-detail-row'>
                                                            
                                                                <div className="station-detail-childt" style={{width: '100%'}}>
                                                                        <div style={{display:'flex', alignItems:'center'}}>
                                                                            <label className={'general-label'}>Area classification</label>
                                                                            <div onClick={()=>setShowLOS(!showLOS)} style={{background:'#717171', height:'20px', width: '20px', borderRadius: '50px', display:'flex', justifyContent:'center', alignItems:'center', marginLeft: '5px', cursor: 'pointer'}}><FontAwesomeIcon icon={faQuestion} style={{color: "white",width:'0.45em'}} /></div>
                                                                        </div>
                                                                        <div style={{width: '100%'}}>
                                                                            <select 
                                                                                id="state_road_select" 
                                                                                name="state_road_select" 
                                                                                style={{width:'440px'}}  
                                                                                className={areaClassError ? "general-text-input error" : "general-text-input"} 
                                                                                onChange={handleChange('FK_area_classification_id')}
                                                                                value={selectedAreaClassification}
                                                                            >
                                                                                <option value="">Select an area classification</option>
                                                                            {areaClassifications.map(item=>(
                                                                                <option value={item['id']}>{item['name']} - {item['code']}</option>
                                                                            ))}
                                                                            </select>
                                                                        </div>
                                                                </div>  
                                                            </div>

                                                            <div className='station-detail-row'>    
                                                                        <div className="station-detail-childt">
                                                                            <label className={'general-label'}>State road</label>
                                                                            <select
                                                                            IconComponent={ExpandMoreIcon}
                                                                            id="state_road_select" 
                                                                            name="state_road_select" 
                                                                            style={{width:'88px'}}  
                                                                            className={' general-text-input' } 
                                                                            value={stateRoad}
                                                                            onChange={handleChange('state_roadway')} data-testid="state_road_select">
                                                                                <option value="Yes">Yes</option>
                                                                                <option value="No">No</option>
                                                                            </select>
                                                                        </div>
                                                                        <div className="station-detail-childt">
                                                                            <label className={'general-label'}>Posted Speed Limit</label>
                                                                            <FilledInput   
                                                                            style={{width:'336px'}}  
                                                                            id="posted_speed_limit" 
                                                                            name="posted_speed_limit"                                                                 
                                                                            type="text" 
                                                                            variant="outlined" 
                                                                            className='form-text-input'
                                                                            value={postedSpeedLimit}
                                                                            onChange={handleChange('posted_speed_limit')}  data-testid="posted_speed_limit" />
                                                                        </div>  
                                                            </div>
                                                            <div className='station-detail-row' style={{width:'100%'}}>
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Number of through lanes for each direction</label>
                                                                </div>
                                                            </div>
                                                            <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>   
                                                                {['NB', 'SB', 'EB', 'WB'].map((item,index)=>(
                                                                    <div className="station-detail-childt" style={{width:'23%'}}>
                                                                    <label className={'general-label'}>{item}</label>
                                                                    <FilledInput   
                                                                    style={{width:'100%'}}  
                                                                    id="state_road_text" 
                                                                    name="state_road_text" 
                                                                    disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                    className={losDirectionsError.includes(item.toLowerCase()) ? "form-text-input-error" : "form-text-input"} 
                                                                            endAdornment={ losDirectionsError.includes(item.toLowerCase()) && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                                                    type="text" 
                                                                    variant="outlined" 
                                                                    value={item === 'NB' ? losNB : item === 'SB' ? losSB : item === 'EB' ? losEB : item === 'WB' ? losWB : null}
                                                                    onChange={handleChange(`${item.toLocaleLowerCase()}_num_lanes`)} data-testid="state_road_text" />
                                                                </div>  
                                                                ))}
                                                            </div>
                                                            <div className='station-detail-row' style={{width:'100%'}}>
                                                                <div className="station-detail-childt">
                                                                    <label className={'general-label'}>Left Turn within 100 yards of station</label>
                                                                </div>
                                                            </div>
                                                            <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>
                                                                {['NB', 'SB', 'EB', 'WB'].map(item=>(
                                                                    <div className="station-detail-childt" style={{width:'23%'}}>
                                                                        <label className={'general-label'}>{item}</label>
                                                                        <select
                                                                        IconComponent={ExpandMoreIcon}
                                                                        id="state_road_select" 
                                                                        name="state_road_select" 
                                                                        style={{width:'100%'}}  
                                                                        className={' general-text-input' } 
                                                                        disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                        value={item === 'NB' ? losNBTurn : item === 'SB' ? losSBTurn : item === 'EB' ? losEBTurn : item === 'WB' ? losWBTurn : null}
                                                                        onChange={handleChange(`${item.toLocaleLowerCase()}_left_turn_within_100_yards`)} data-testid="state_road_select">
                                                                            <option value="Yes">Yes</option>
                                                                            <option value="No">No</option>
                                                                        </select>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className='station-detail-row' style={{width:'100%'}}>    
                                                                <div className="station-detail-childt" style={{width:'100%'}}>
                                                                    <label className={'general-label'}>Median type</label>
                                                                    <select 
                                                                        IconComponent={ExpandMoreIcon}
                                                                        id="median_type_select" 
                                                                        name="median_type_select" 
                                                                        style={{width:'100%'}}  
                                                                        value={medianType}
                                                                        className={medianTypeError ? "general-text-input error" : "general-text-input"} 
                                                                        onChange={handleChange('FK_median_type_id')} data-testid="median_type_select">
                                                                        <option value="">Select a median type</option>
                                                                    {medianTypes.map(item=>(
                                                                        <option value={item['id']}>{item['name']}</option>
                                                                    ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            
                                                            <div className='station-detail-row' style={{width:'100%'}}>    
                                                                        <div className="station-detail-childt" style={{width:'48%'}}>
                                                                            <label className={'general-label'}>Exclusive Left Turn Lane</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>
                                                                        {['NB', 'SB', 'EB', 'WB'].map(item=>(
                                                                            <div className="station-detail-childt" style={{width:'23%'}}>
                                                                                <label className={'general-label'}>{item}</label>
                                                                                <select
                                                                                IconComponent={ExpandMoreIcon}
                                                                                id="state_road_select" 
                                                                                name="state_road_select" 
                                                                                style={{width:'100%'}}  
                                                                                className={' general-text-input' } 
                                                                                disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                                value={item === 'NB' ? nbExclusiveLeft : item === 'SB' ? sbExclusiveLeft : item === 'EB' ? ebExclusiveLeft : item === 'WB' ? wbExclusiveLeft : null}
                                                                                onChange={handleChange(`${item.toLocaleLowerCase()}_exclusive_left_turn_lane`)} data-testid="state_road_select">
                                                                                    <option value="Yes">Yes</option>
                                                                                    <option value="No">No</option>
                                                                                </select>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                                    <div className='station-detail-row' style={{width:'100%'}}>    
                                                                        <div className="station-detail-childt" style={{width:'48%'}}>
                                                                            <label className={'general-label'}>Exclusive Right Turn Lane</label>
                                                                        </div>
                                                                    </div>
                                                                    <div className='station-detail-row' style={{width:'100%', paddingTop:'2px'}}>
                                                                        {['NB', 'SB', 'EB', 'WB'].map(item=>(
                                                                            <div className="station-detail-childt" style={{width:'23%'}}>
                                                                                <label className={'general-label'}>{item}</label>
                                                                                <select
                                                                                IconComponent={ExpandMoreIcon}
                                                                                id="state_road_select" 
                                                                                name="state_road_select" 
                                                                                style={{width:'100%'}}  
                                                                                className={' general-text-input' } 
                                                                                disabled={!losDisabledApproaches.includes(item.toLowerCase())}
                                                                                value={item === 'NB' ? nbExclusiveRight : item === 'SB' ? sbExclusiveRight : item === 'EB' ? ebExclusiveRight : item === 'WB' ? wbExclusiveRight : null}
                                                                                onChange={handleChange(`${item.toLocaleLowerCase()}_exclusive_right_turn_lane`)} data-testid="state_road_select">
                                                                                    <option value="Yes">Yes</option>
                                                                                    <option value="No">No</option>
                                                                                </select>
                                                                            </div>
                                                                        ))}
                                                                    </div>

                                                            <div className='station-detail-row' style={{width:'100%'}}>    
                                                                <div className="station-detail-childt" style={{width:'48%'}}>
                                                                    <label className={'general-label'}>One-Way Roadway</label>
                                                                    <select
                                                                    IconComponent={ExpandMoreIcon}
                                                                    id="one_way_roadway_select" 
                                                                    name="one_way_roadway_select" 
                                                                    style={{width:'100%'}}  
                                                                    className={' general-text-input' } 
                                                                    value={oneWayRoadway}
                                                                    onChange={handleChange('one_way_roadway')} data-testid="one_way_roadway_select">
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>
                                                                    </select>
                                                                </div>
                                                                <div className="station-detail-childt" style={{width:'48%'}}>
                                                                    <label className={'general-label'}>Auxiliary Lanes</label>
                                                                    <select
                                                                    IconComponent={ExpandMoreIcon}
                                                                    id="auxiliary_lanes_select" 
                                                                    name="auxiliary_lanes_select" 
                                                                    style={{width:'100%'}}  
                                                                    className={' general-text-input' } 
                                                                    value={auxiliaryLanes}
                                                                    onChange={handleChange('auxiliary_lanes')} data-testid="auxiliary_lanes_select">
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>
                                                                    </select>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                            }
                                            </div>
                                        }
                                    </div>
                                </div>
                             

                            </div>
              
                      
                        </div>
                        <div className={'station-detail-panel-footer'}>
                            <Button variant="outlined" 
                            id="cancel_btn" 
                            data-testid="cancel_btn" 
                            style={{width:'71px', height:'34px'}}
                            className={'bg-gray-500 txt-gray-700 font-14'} 
                            onClick={() => { clearStationForm() }}>
                                Cancel</Button>&nbsp;&nbsp;
                            <Button 
                            type="submit" 
                            variant="outlined" 
                            id="update_Station_btn" 
                            data-testid="update_Station_btn" 
                            style={{width:'57px', height:'34px'}}
                            disabled={displayNameError==true || stationIdError == true || stationLocationError == true || stationLatitudeError == true || stationLongitudeError == true  || aproachDetailsError[0]  == true || aproachDetailsError[1]  == true  || aproachDetailsError[2]  == true || aproachDetailsError[3]  == true? true : false}
                            
                            className={"blue-btn font-14 "}
                            >
                                
                                Save</Button>
                        </div>
                        </div>
                        </TabPanel>
                                    
                    </SwipeableViews>
                   
                </form>  
                </Container>
               
            </div>
            {
                (showLaneConfig && stationType === 2) &&
                <LaneGeometry 
                    lat={lat}
                    long={long}
                    stationType={stationType}
                    setShowLaneConfig={setShowLaneConfig}
                    approachesForLane={approachesForLane}
                    stationId={sessionStorage.getItem('viewStationId')}
                    laneConfigId={laneConfigId}
                    setLaneConfigId={setLaneConfigId}
                    getStationDetails={getStationDetails}
                    geocodeAcccessToken={geocodeAcccessToken}
                    showLaneConfig={showLaneConfig}
                /> 
            }
             {
                showLOS &&
                (<React.Fragment>  
                    <CssBaseline />
                        <div className="management-main">
                            <Container className="station-management-container" maxWidth="lg">
                            <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => validateForm(e)} data-testid='station_details_from'>
                                <AppBar position="static" color="default" className={(scrolled?'table-scrolled':'') + ' tabs-header station-tabs' }>
                                    <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                    aria-label="full width tabs example"
                                    >
                                        <Tab label="Area classification guide" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={'main_panel_title_specific main_panel_title'}  style={{ width: '210px', maxWidth: '210px', maxWidth: '210px !important' }} />
                                    </Tabs>
                                    <div className="add-user-cnt">
                                        <img src={require('../../assets/icons/close.svg')} onClick={() => setShowLOS(false)} />
                                    </div>
                                </AppBar>
                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={value}
                                    onChangeIndex={handleChangeIndex}
                                    className={'main_bg'}
                                >
                                    <TabPanel value={value} index={0} dir={theme.direction} >
                                  
                                    <div>
                                    <div className="stations-detail-content ddd "
                                     onScroll={handleScroll}
                                     ref={mainBgRef} >
                                        <div className={'station_container'}>
                                            <div className={'station_container_row'} style={{width: '100%'}}>
                                                <div className="station_card_info m-r-16" style={{width: '100%'}}>
                                                    <img src={require('../../assets/images/LOS_image.png')} style={{width:'100%', height:'350px'}} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    </TabPanel>
                                </SwipeableViews>
                            </form>
                            </Container>
                        </div>
                    </React.Fragment>
            )
            }
        </React.Fragment>
       
    );
}
export default StationDetails;
//End StationDetails component code ....